var _style, _style2, _ellipse, _g, _path, _path2, _path3, _path4, _path5, _g2, _g3, _path6, _path7, _path8, _g4, _path9, _path0, _path1, _path10, _g5, _path11, _path12, _path13, _g6, _g7, _g8, _g9, _g0, _g1, _ellipse2, _ellipse3, _g10, _g11, _g12, _path14, _g13, _g14, _g15, _path15, _path16, _path17, _ellipse4, _ellipse5, _g16, _g17, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _ellipse0, _ellipse1, _ellipse10, _ellipse11, _ellipse12, _ellipse13, _ellipse14, _path18, _ellipse15, _ellipse16, _ellipse17, _ellipse18, _ellipse19, _ellipse20, _ellipse21, _ellipse22, _path19, _ellipse23, _path20, _path21, _path22, _ellipse24, _path23, _path24, _path25, _ellipse25, _ellipse26, _ellipse27, _ellipse28;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPromoterHeader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    style: {
      enableBackground: "new 0 0 1375.5 399"
    },
    xmlSpace: "preserve",
    viewBox: "81.2 104.45 1206 229.85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#444444;stroke:#404040;stroke-miterlimit:10;}\n\t.st1{fill:#E3E3E3;}\n\t.st2{fill:#666666;}\n\t.st3{fill:#C1C1C1;}\n\t.st4{fill:#676767;}\n\t.st5{fill:#818181;}\n\t.st6{fill:#F0F0F0;}\n\t.st7{fill:none;stroke:#B5B5B5;stroke-miterlimit:10;}\n\t.st8{fill:#B5B5B5;}\n\t.st9{fill:none;stroke:#B5B5B5;stroke-miterlimit:10.01;}\n\t.st10{fill:#F0F0F0;stroke:#B5B5B5;stroke-miterlimit:10;}\n\t.st11{fill:#F0F0F0;stroke:#000000;stroke-miterlimit:10;}\n\t.st12{fill:#B5B5B5;stroke:#B5B5B5;stroke-miterlimit:10;}\n\t.st13{fill:#B5B5B5;stroke:#B5B5B5;stroke-miterlimit:10.01;}\n\t.st14{fill:#B5B5B5;stroke:#B5B5B5;stroke-width:1.0032;stroke-miterlimit:10.0319;}\n\t.st15{fill:#B5B5B5;stroke:#B5B5B5;stroke-width:0.9964;stroke-miterlimit:9.9644;}\n\t.st16{fill:none;stroke:#544A4A;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st17{fill:none;stroke:#544A4A;stroke-miterlimit:10;}\n\t.st18{fill:#00FF00;stroke:#000000;stroke-miterlimit:10;}\n\t.st19{fill:#00FF00;stroke:#000000;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st20{fill:#FBB03B;}\n\t.st21{fill:#D9E021;}\n\t.st22{fill:#BD73EA;}\n\t.st23{fill:#7AD3AB;}\n\t.st24{fill:#E6BDB7;}\n\t.st25{fill:#71D1D1;}\n\t.st26{fill:#FF8B5C;}\n\t.st27{fill:#D1CB7B;}\n\t.st28{fill:#C5669E;}\n\t.st29{fill:#DDADFF;}\n\t.st30{fill:#00A99D;}\n\t.st31{fill:#0000FF;}\n\t.st32{fill:#ED1C24;}\n\t.st33{fill:#006837;}\n\t.st34{fill:#B1337D;}\n\t.st35{fill:#B4FF33;}\n\t.st36{fill:#283A87;}\n\t.st37{fill:#FF00FF;}\n\t.st38{fill:#5A801A;}\n\t.st39{fill:#FFFF00;}\n\t.st40{fill:#00FF00;}\n\t.st41{fill:#7BC1D1;}\n\t.st42{fill:#800080;}\n\t.st43{fill:#93278F;}\n\t.st44{fill:#F14B94;}\n\t.st45{fill:#F4777C;}\n\t.st46{fill:#3FA9F5;}\n\t.st47{fill:#00FFFF;}\n\t.st48{fill:#C57BD6;}\n\t.st49{fill:#F2F2F2;}\n\t.st50{fill:none;stroke:#000000;stroke-miterlimit:10;}\n\t.st51{fill:#F2F2F2;stroke:#F2F2F2;stroke-miterlimit:10;}\n\t.st52{fill:#F2F2F2;stroke:#000000;stroke-miterlimit:10;}\n\t.st53{fill:#B3B3B3;stroke:#000000;stroke-miterlimit:10;}\n")), _style2 || (_style2 = /*#__PURE__*/React.createElement("style", {
    className: "darkreader darkreader--sync",
    media: "screen"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1",
    className: "st0",
    cx: 684.2,
    cy: 301.2,
    rx: 602.5,
    ry: 32.6
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_46"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_177",
    className: "st1",
    d: "M1270.7,130.5c-0.2-1.7-0.8-3.4-1.8-4.8c-1.3-1.6-2.9-2.8-4.8-3.5c-2.5-1-5.1-1.4-7.8-1.4   c-1.9,0-3.8,0.1-5.8,0.2l-2,0.1c-6.8,0.4-12.8,0.7-18.4,1c-13.6,0.8-25.5,1.7-36.6,2.7c-36.6,3.4-66.8,8.3-94.9,15.6   c-61,15.8-120.8,31-181.9,43c-26.1,5.1-52.6,7.4-79.2,7c-46.1-0.8-93.4-10.2-140.5-27.9c-7-2.7-14-5.3-21.1-8   c-31.8-12.1-64.6-24.6-97.5-34.3c-33.5-9.9-66.8-15.2-99-15.7c-41.8-0.7-83.4,6.6-122.5,21.7c-50,19.1-97.8,43.6-142.4,73.3   c-12.7,8.5-24.9,18.9-37.8,29.9c-25.8,22-52.5,44.7-83.2,51.1l-0.8,0.2c-2.4,0.4-4.7,1.1-6.8,2.1c-0.2,2-0.6,3.9-1.2,5.8   c-0.1,0.5-0.3,0.9-0.4,1.4c42.8-5,90.5-16.3,141.9-33.7l3.5-1.1c76.4-25.9,155.5-52.6,237.5-51.2c6.9,0.1,13.8,0.4,20.5,0.9   c78.4,5.9,155.2,32.2,229.5,57.6l15,5.1c24.2,8.2,50.1,12.3,81.5,12.9c21.6,0.4,43.8-1,62.9-2.4c52.6-3.7,104.1-20.8,151.9-38.7   c82.4-30.9,144.4-55.6,179.3-71.6c12.7-5.8,25.4-11.9,38-18c5.1-2.5,10.2-5,15.3-7.5c0.7-0.4,1.5-0.7,2.2-1c3.8-1.7,7-3.2,7.7-7.3   C1271,132.8,1271,131.6,1270.7,130.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_178",
    className: "st2",
    d: "M1269.8,140.8c0-0.3-0.1-0.6-0.2-0.9c-1.1,3.1-4,4.5-7.4,6c-0.7,0.3-1.5,0.7-2.2,1   c-5.1,2.5-10.3,5.1-15.4,7.5c-12.6,6.1-25.4,12.2-38.2,18c-35,16-97.3,40.8-180.1,71.7c-48,17.9-99.8,35-152.6,38.5   c-19.2,1.3-41.4,2.7-63.1,2.3c-31.6-0.6-57.6-4.8-81.9-13.1l-15-5.2c-74.6-25.7-151.7-52.2-230.4-58.2c-6.8-0.5-13.7-0.9-20.6-1   c-82.3-1.6-161.7,25.2-238.6,51l-3.4,1.2c-49.5,16.6-95.6,27.6-137.1,32.9c-0.4,1.4-0.9,2.9-1.3,4.3c-0.1,0.5-0.3,1-0.4,1.5   c42-5.1,88.6-16.2,138.7-33.1l3.4-1.2c76.8-25.9,156.3-52.6,238.6-51c6.9,0.1,13.9,0.5,20.6,1c78.7,6,155.8,32.5,230.4,58.2l15,5.2   c24.2,8.3,50.3,12.5,81.9,13.1c21.7,0.4,44-1,63.1-2.2c52.8-3.6,104.5-20.7,152.6-38.6c82.8-30.9,145.1-55.6,180.1-71.7   c12.7-5.8,25.6-11.9,38.2-18c5.1-2.5,10.3-5,15.4-7.5c0.7-0.4,1.5-0.7,2.2-1c3.8-1.7,7.1-3.2,7.7-7.3   C1270,143.1,1270,141.9,1269.8,140.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_179",
    className: "st3",
    d: "M1269.8,136.1c0-0.3-0.1-0.6-0.2-0.9c-1.1,3.1-4,4.5-7.4,6c-0.7,0.3-1.5,0.7-2.2,1   c-5.1,2.5-10.3,5.1-15.4,7.5c-12.6,6.1-25.4,12.2-38.2,18c-35,16-97.3,40.9-180.1,71.7c-48,17.9-99.8,35-152.6,38.6   c-19.2,1.3-41.4,2.7-63.1,2.2c-31.6-0.6-57.6-4.8-81.9-13.1l-15-5.2c-74.6-25.6-151.7-52.2-230.4-58.2c-6.8-0.5-13.7-0.9-20.6-1   c-82.3-1.6-161.8,25.2-238.6,51l-3.5,1.2c-48.9,16.5-94.5,27.4-135.6,32.7l-0.3,1c-0.4,1.6-0.9,3.2-1.4,4.8   c41.6-5.2,87.7-16.2,137.2-32.9l3.4-1.2c76.8-25.9,156.3-52.6,238.6-51c6.9,0.1,13.8,0.5,20.6,1c78.7,6,155.8,32.6,230.4,58.2   l15,5.2c24.2,8.3,50.3,12.5,81.9,13.1c21.7,0.4,44-1,63.1-2.3c52.8-3.6,104.5-20.6,152.6-38.5c82.8-30.9,145.1-55.6,180.1-71.7   c12.7-5.8,25.6-11.9,38.2-18c5.1-2.5,10.3-5,15.4-7.5c0.7-0.4,1.5-0.7,2.2-1c3.8-1.7,7.1-3.2,7.7-7.3   C1270,138.4,1270,137.2,1269.8,136.1z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_180",
    className: "st4",
    d: "M1097.5,167.7c-0.5-1.8-0.9-3.5-0.9-3.5v-0.2c-16.9,11.2-34.6,21.3-52.9,30.1  c-15.9,7.7-36.6,17.7-63,24.5c-31,7.8-63.1,10-94.9,6.3c-30.1-3.5-34.6-8.9-119.3-39.9c-42.3-15.5-73.9-26.1-134.2-46.2  c-36.5-12.2-55-18.4-63-20.3c-35.8-8.6-92.6-23.1-147.1-4.2c-17.3,6-29.2,15.2-42,28.1c-18.6,18.7-46.7,32.8-69.1,46.2  c-24.8,14.8-50.7,28-78,36.9c-8.3,2.7-16.7,5.1-24.4,9.4c-11.7,6.7-20.7,17.4-25.3,30.1c33.2-12.5,65.1-28,95.4-46.5  c34-20.8,65.9-45.5,101.1-64.2c35.4-18.8,74.6-31.2,114.5-32.7c41.8-1.6,81.7,12.5,120.8,26c56.2,19.3,111.8,40.7,165.8,65.7  c25.9,12,51.5,24.8,78.7,32.9c50.5,15,99,2.6,147.3-14.9c34.4-12.5,67.5-28.3,98.9-47C1100.8,175.7,1097.9,169,1097.5,167.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_181",
    className: "st5",
    d: "M882.5,270.4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_182",
    className: "st5",
    d: "M787.6,138.6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_183",
    className: "st5",
    d: "M459.5,91"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_184",
    className: "st5",
    d: "M409.4,79.8"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_49"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_47"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7239 -0.6899 0.6899 0.7239 -20.5869 313.3875)",
    className: "st6",
    cx: 381.3,
    cy: 182.4,
    rx: 31.6,
    ry: 22.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7243 -0.6895 0.6895 0.7243 -20.6244 313.1713)",
    className: "st7",
    cx: 381.3,
    cy: 182.4,
    rx: 31.3,
    ry: 22.1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_48"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_3"
  }, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.351 -0.9364 0.9364 0.351 76.446 475.3096)",
    className: "st8",
    cx: 381.1,
    cy: 182.5,
    rx: 6.1,
    ry: 5.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.3553 -0.9348 0.9348 0.3553 75.1003 473.95)",
    className: "st9",
    cx: 381.1,
    cy: 182.5,
    rx: 5.8,
    ry: 5
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_51"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_50"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_4"
  }, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1104 -0.9939 0.9939 0.1104 300.4952 673.5545)",
    className: "st6",
    cx: 526.5,
    cy: 168.9,
    rx: 37.2,
    ry: 22.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1104 -0.9939 0.9939 0.1104 300.4895 673.4882)",
    className: "st7",
    cx: 526.5,
    cy: 168.9,
    rx: 36.9,
    ry: 21.9
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_185",
    className: "st10",
    d: "M515.9,156.3c-0.3,2.2,0.9,4.1,2.6,6.9c2,3.1,3.2,5,5.3,5.2c2.3,0.2,4.2-2,5.6-3.8   s3.6-4.4,3.2-7.5c-0.3-1.9-1.6-3.2-4.2-5.6c-2.1-2-3.1-3-4.6-2.9s-2.5,1-4.5,2.9C517.2,153.6,516.2,154.6,515.9,156.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_186",
    className: "st11",
    d: "M484.3,170.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_187",
    className: "st10",
    d: "M526.8,169.2c0,2.3,1.4,3.9,3.5,6.2c2.4,2.6,3.9,4.3,5.9,4.1c2.3-0.3,3.8-2.9,5-4.9   c1.2-2,3-5.1,2.1-8c-0.4-1.4-1.2-1.6-4.9-4.7c-1.6-1.3-2.8-2.5-3.7-3.2c-0.4-0.3-0.9-0.4-1.4-0.3c-1.4,0.2-2,2-3.9,5.5   C527.3,168,526.8,167.9,526.8,169.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_188",
    className: "st10",
    d: "M548,181.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_189",
    className: "st10",
    d: "M516.6,179.5c-0.3,2.2,0.9,4.1,2.7,6.9c2,3.1,3.2,5,5.2,5.2c2.3,0.2,4.2-2,5.6-3.8   s3.6-4.4,3.2-7.5c-0.3-1.9-1.5-3.2-4.1-5.6c-2.1-2-3.1-3-4.6-2.9s-2.5,1-4.5,2.9C517.9,176.8,516.9,177.8,516.6,179.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_190",
    className: "st10",
    d: "M525.6,145.8c-0.3,0.6-0.5,1.4-0.5,2.1c0.2,1.7,1.8,1.9,4,4c2.4,2.4,2.7,4.3,4.4,4.4   c0.5,0,1-0.2,1.5-0.4c2.1-1.1,3.9-2.7,5.1-4.7c2.2-3.1,3.3-4.8,3.2-7.1c-0.2-3.4-3-5.6-4.5-6.8c-1.5-1.2-3.2-2.5-5.3-2   c-1.3,0.3-2.6,1.9-5.1,5.2C527.3,142.1,526.3,143.9,525.6,145.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_191",
    className: "st10",
    d: "M527.5,136.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_192",
    className: "st10",
    d: "M533.9,157.5c0.1,0.6,0.5,0.8,2.6,2.4c4.7,3.5,5,4.1,6.4,4.2c0.2,0,3.1,0.1,4.4-2.2   c0.7-1.3,0.5-2.8,0.2-5.8s-0.8-2.7-1.3-6.4c-0.1-0.9-0.4-1.7-0.7-2.5c-0.4-0.8-0.7-1.5-1.2-1.6c-1.1-0.3-2,2.6-4.1,5.5   C536.9,155.3,533.8,155.7,533.9,157.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_193",
    className: "st10",
    d: "M541,155"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_194",
    className: "st10",
    d: "M515.3,141.4c-0.5,2.1,1.8,5.6,4.6,6.5c1,0.3,2,0.3,2.9-0.1c1.7-0.7,2-2.3,4-5.6   c2.5-4.1,4.8-5.8,4.2-7.2c-0.2-0.5-0.5-0.8-0.9-1.1c-0.7-0.6-1.5-0.9-2.4-1c-1.5-0.1-2.6,0.5-4.7,1.7c-0.7,0.4-1.4,0.9-2,1.4   c-0.4,0.3-0.6,0.5-1.7,1.5c-1.4,1.2-1.4,1.1-1.7,1.5C516.2,140,515.5,140.6,515.3,141.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_195",
    className: "st10",
    d: "M519.3,132.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_196",
    className: "st10",
    d: "M505.5,167.5c-0.3,2.2,0.9,4.1,2.6,6.9c2,3.1,3.2,5,5.3,5.2c2.3,0.2,4.2-2,5.6-3.8   s3.6-4.4,3.2-7.5c-0.3-1.9-1.6-3.2-4.2-5.6c-2.1-2-3.1-3-4.6-2.9s-2.5,1-4.5,2.9C506.8,164.8,505.7,165.8,505.5,167.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_197",
    className: "st10",
    d: "M506.8,188c-0.5,1.6,0.5,3.3,1.9,5.8c1.6,2.7,2.6,4.5,4.5,5c2.2,0.6,4.1-0.7,5.6-1.8   s3.8-2.7,3.7-5.1c-0.1-1.5-1.2-2.7-3.5-5.1c-1.8-1.9-2.7-2.9-4.1-3.1c-1.4-0.3-2.5,0.3-4.5,1.4C508.3,186.1,507.2,186.7,506.8,188z   "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_198",
    className: "st10",
    d: "M504.7,178.1c0,1,0.1,2.1,0.3,3.1c0.7,3.4,1.1,5.1,1.8,5.3c0.4,0.1,1-0.3,2.2-1.1   c0.3-0.2,0.6-0.4,0.9-0.6c0.9-0.7,1.5-1.1,1.8-1.9c0.2-0.7,0.2-1.5,0-2.2c-0.3-1.2-0.8-1.4-2.1-3.1c-1.5-2-1.7-2.9-2.5-3   c-0.7,0-1.3,0.3-1.7,0.8C504.9,176.3,504.7,177.2,504.7,178.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_199",
    className: "st10",
    d: "M516.3,154.4c2.3-3.1,3.8-3.6,3.7-4.7c-0.1-0.6-0.5-0.5-1.9-1.8c-0.9-0.9-1.8-1.8-2.5-2.9   c-1-1.3-1.1-1.7-1.6-1.7c-0.8-0.1-1.5,1.1-2.2,2.2s-0.7,1.7-1.6,3.3c-0.5,0.8-0.6,0.9-1,1.6c-0.9,1.6-1.4,2.5-1.2,3.4   c0.1,0.5,0.3,0.9,1.9,2.3c3,2.7,3.6,3,4,2.7c0.3-0.2,0.3-0.5,0.6-1.2C514.8,156.5,515.5,155.4,516.3,154.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_200",
    className: "st10",
    d: "M513.9,146.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_201",
    className: "st10",
    d: "M518.6,149"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_202",
    className: "st10",
    d: "M515.4,150.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_203",
    className: "st10",
    d: "M508.5,159.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_204",
    className: "st10",
    d: "M510.5,160.9l1.3-1.1c0.7-0.5,0.8-0.5,0.9-0.7c0-0.5-0.9-0.7-2.3-1.9c-0.5-0.4-0.9-0.8-1.3-1.2   c-0.8-0.8-1-1.3-1.3-1.2c-0.6,0.1-0.9,1.4-1,1.6c-0.1,0.3-0.1,0.6-0.1,0.9c0,0.2,0.1,0.4,0,0.5c-0.1,0.1-0.2,0.3-0.3,0.4l-0.1,0.2   c-0.2,0.4-0.4,0.8-0.4,1.3c-0.2,0.7-0.1,1.4,0.1,2c0.2,0.6,0.7,1,1.3,1.2c0.4,0.1,0.8,0,1.1-0.2c0.3-0.2,0.6-0.4,0.9-0.7   C509.7,161.6,510.1,161.3,510.5,160.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_205",
    className: "st11",
    d: "M504.6,158.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_206",
    className: "st10",
    d: "M530.9,188c0,1.6,1,2.7,2.6,4.4c1.7,1.8,2.8,3,4.3,2.8c1.7-0.2,2.8-2,3.7-3.5s2.1-3.6,1.6-5.7   c-0.3-1-0.9-1.2-3.5-3.3c-1.1-0.9-2.1-1.7-2.7-2.3c-0.3-0.2-0.7-0.3-1-0.2c-1,0.2-1.5,1.4-2.8,3.9   C531.2,187.1,530.9,187.1,530.9,188z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_207",
    className: "st10",
    d: "M523.5,194.3c-0.4,1.4,0.5,2.8,1.8,4.8c1.4,2.2,2.3,3.6,3.9,3.9c1.8,0.4,3.3-1,4.5-2   s3-2.6,2.8-4.6c-0.1-1-0.7-1.3-3-4c-1-1.2-1.8-2.2-2.3-2.9c-0.3-0.3-0.6-0.4-1-0.5c-1.1-0.2-1.8,0.9-3.7,2.6   C524.1,193.7,523.7,193.5,523.5,194.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_208",
    className: "st10",
    d: "M539.1,180.2c0,1,0.6,1.8,1.6,2.8s1.7,1.9,2.5,1.8s1.6-1.3,2-2.2c0.7-1.1,1-2.4,0.8-3.7   c-0.2-0.6-0.5-0.7-2.1-2.1c-0.7-0.6-1.2-1.1-1.6-1.4c-0.2-0.1-0.4-0.2-0.6-0.1c-0.6,0.1-0.8,0.9-1.6,2.5   C539.3,179.7,539.1,179.7,539.1,180.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_209",
    className: "st10",
    d: "M517.7,204.5c0.8,0.2,1.7,0.2,2.5,0c2.8-0.4,4.2-0.6,4.5-1.4c0.1-0.4-0.1-1.2-0.5-2.9   c-0.1-0.4-0.2-0.8-0.3-1.1c-0.2-0.9-0.6-1.7-1.2-2.4c-0.5-0.4-1.1-0.5-1.8-0.4c-1,0.2-1.2,0.8-2.8,2.1c-1.8,1.6-2.5,1.6-2.8,2.6   c-0.1,0.8,0,1.5,0.4,2.2C516.2,203.9,516.9,204.3,517.7,204.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_210",
    className: "st10",
    d: "M544.6,174.6c0.8-0.4,1.4-0.9,2-1.6c0.6-0.6,1.1-1.4,1.5-2.1c0.6-2.7,0.2-3.3,0-3.5l-0.5-0.4   c-0.3-0.3-0.6-0.5-1-0.8c-0.4-0.2-0.9-0.3-1.3-0.2c-0.5,0.1-1,0.3-1.4,0.7c-0.1,0.1-0.3,0.3-0.4,0.5c-0.4,0.9-0.7,1.9-1,2.9   c-0.8,2.3-1.4,2.8-1.2,3.7c0.2,0.6,0.6,1.1,1.2,1.3C543.2,175.2,544,175,544.6,174.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_211",
    className: "st10",
    d: "M552.6,175.9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_5",
    transform: "matrix(2.967024e-03 -1 1 2.967024e-03 342.5879 683.5302)",
    className: "st12",
    cx: 514.1,
    cy: 170,
    rx: 2.8,
    ry: 2.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_6",
    className: "st12",
    cx: 522.8,
    cy: 157,
    rx: 2.3,
    ry: 2.8
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_7",
    transform: "matrix(1.064632e-02 -0.9999 0.9999 1.064632e-02 337.6646 705.5344)",
    className: "st12",
    cx: 525.4,
    cy: 182.1,
    rx: 2.8,
    ry: 2.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_8",
    transform: "matrix(2.967024e-03 -1 1 2.967024e-03 321.2456 704.129)",
    className: "st12",
    cx: 513.7,
    cy: 191,
    rx: 2.8,
    ry: 2.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_9",
    transform: "matrix(2.967024e-03 -1 1 2.967024e-03 364.8212 703.4828)",
    className: "st12",
    cx: 535.2,
    cy: 168.8,
    rx: 2.8,
    ry: 2.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_10",
    transform: "matrix(2.967024e-03 -1 1 2.967024e-03 388.3123 679.2017)",
    className: "st12",
    cx: 534.8,
    cy: 144.9,
    rx: 2.8,
    ry: 2.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_11",
    transform: "matrix(2.565355e-02 -0.9997 0.9997 2.565355e-02 371.0371 695.0776)",
    className: "st12",
    cx: 542.1,
    cy: 157.2,
    rx: 2.4,
    ry: 1.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_12",
    transform: "matrix(2.565355e-02 -0.9997 0.9997 2.565355e-02 334.7243 720.5671)",
    className: "st12",
    cx: 537,
    cy: 188.6,
    rx: 2.4,
    ry: 1.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_13",
    transform: "matrix(2.565355e-02 -0.9997 0.9997 2.565355e-02 320.2925 720.884)",
    className: "st12",
    cx: 530,
    cy: 196.1,
    rx: 2.4,
    ry: 1.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_14",
    transform: "matrix(4.361939e-02 -0.999 0.999 4.361939e-02 296.6237 711.8594)",
    className: "st12",
    cx: 520.1,
    cy: 201,
    rx: 1.7,
    ry: 1.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_15",
    transform: "matrix(1.308960e-02 -0.9999 0.9999 1.308960e-02 355.994 720.06)",
    className: "st12",
    cx: 542.8,
    cy: 179.7,
    rx: 1.4,
    ry: 1.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_16",
    transform: "matrix(1.308960e-02 -0.9999 0.9999 1.308960e-02 368.018 713.2343)",
    className: "st12",
    cx: 545.3,
    cy: 170.2,
    rx: 1.4,
    ry: 1.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_17",
    transform: "matrix(5.982905e-02 -0.9982 0.9982 5.982905e-02 296.4245 676.6934)",
    className: "st12",
    cx: 507.4,
    cy: 181,
    rx: 1.5,
    ry: 1.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_18",
    transform: "matrix(1 -7.504846e-03 7.504846e-03 1 -1.1815 3.819)",
    className: "st12",
    cx: 508.3,
    cy: 159.3,
    rx: 1,
    ry: 1.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_19",
    transform: "matrix(0.9996 -2.757271e-02 2.757271e-02 0.9996 -3.9743 14.22)",
    className: "st12",
    cx: 513.6,
    cy: 151.2,
    rx: 1.7,
    ry: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_20",
    transform: "matrix(0.9996 -2.757271e-02 2.757271e-02 0.9996 -3.6651 14.4731)",
    className: "st12",
    cx: 523,
    cy: 140.1,
    rx: 1.7,
    ry: 2
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_212",
    className: "st10",
    d: "M421.6,178.5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_213",
    className: "st10",
    d: "M424.9,164.8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_214",
    className: "st10",
    d: "M438.7,182.9"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_52"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_21"
  }, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(3.018967e-02 -0.9995 0.9995 3.018967e-02 257.9256 601.2939)",
    className: "st6",
    cx: 438.8,
    cy: 167.7,
    rx: 35.4,
    ry: 21.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(3.036402e-02 -0.9995 0.9995 3.036402e-02 257.8496 601.3749)",
    className: "st7",
    cx: 438.9,
    cy: 167.8,
    rx: 35,
    ry: 20.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_215"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M439.1,201.1L439.1,201.1c-1.1,0-2.1-0.1-3.2-0.3c-1.5-0.3-2.9-0.9-4.2-1.7c-1.3-0.8-2.6-1.9-3.7-3    c-2.2-2.3-4-4.9-5.2-7.8c-1.6-3.7-2.1-7.1-1.2-8.8c0,0,0.1-0.2,0.9-0.4c0.8-0.2,1.7-0.4,2.6-0.5c2.2-0.3,5.2-0.6,9.9-1.1h0.4    c0.6-0.1,1.2-0.1,1.8-0.1c0.8,0,1.7,0.1,2.5,0.3c1.2,0.4,2.3,0.8,3.4,1.4l0,0c1.2,0.5,2.3,1.1,3.4,1.8c1.8,1.2,3.5,2.3,4.3,3.9    c0.8,2,0.8,4.3,0.1,6.3c-0.6,2.4-1.7,4.5-3.3,6.4c-1.1,1.3-2.6,2.4-4.2,3C441.9,200.9,440.5,201.2,439.1,201.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M439.1,201.5v-0.7c1.4,0,2.7-0.2,4-0.7c1.6-0.6,3-1.6,4.1-2.9c1.5-1.8,2.6-4,3.2-6.3c0.7-2,0.6-4.1-0.1-6    c-0.8-1.5-2.4-2.6-4.1-3.7c-1.1-0.7-2.2-1.3-3.3-1.8l0,0c-1.1-0.6-2.2-1-3.3-1.4c-0.8-0.2-1.6-0.3-2.4-0.3c-0.6,0-1.2,0-1.8,0.1    l-0.4,0c-4.4,0.4-7.4,0.7-9.6,1c-1.1,0.1-2,0.3-2.6,0.4c-0.3,0.1-0.7,0.2-1,0.3c-0.4,1.1-0.5,2.2-0.3,3.3c0.3,1.8,0.8,3.5,1.5,5.1    c1.3,2.9,3,5.5,5.2,7.7c1.1,1.1,2.3,2.1,3.6,2.9c1.3,0.8,2.6,1.4,4.1,1.7c1,0.2,2.1,0.3,3.1,0.3L439.1,201.5 M439.1,201.5    c-1.1,0-2.2-0.1-3.2-0.4c-10.2-2.2-17-17.4-14.6-21.8c0.4-0.8,4.8-1.2,13.6-2.1c0.7-0.1,1.5-0.2,2.2-0.2c0.9,0,1.7,0.1,2.6,0.3    c1.2,0.4,2.3,0.8,3.4,1.4c1.2,0.5,2.3,1.1,3.4,1.8c1.8,1.2,3.5,2.3,4.4,4c1.7,3.5-0.2,9.7-3.2,13.1    C445.6,200.2,442.4,201.5,439.1,201.5L439.1,201.5z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_216",
    className: "st10",
    d: "M447.3,179.3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Path_217"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M452.8,184.8c-0.2,0-0.4-0.2-1.1-0.7c-1.1-0.9-2.2-1.7-3.3-2.4l0,0c-1.7-1.3-3.6-2.3-5.5-3.2    c-0.8-0.3-1.6-0.6-2.5-0.8c-1-0.2-1.4-0.3-1.8-1c-0.9-1.3-0.5-3.3-0.2-5.2l0.1-0.5c0.6-3.8,0.9-7.7,0.8-11.6c0-3.3,0-5.1,1.4-6.4    c0.3-0.3,0.4-0.3,2-0.6c0.6-0.1,1.5-0.2,2.7-0.5c3-0.5,5-1,6.2-1.3c0.7-0.2,1.5-0.3,2.2-0.4c0.3,0,0.5,0.1,0.7,0.2    c1.4,0.9,2.1,3,2.4,6.7c0.1,3.8,0,7.6-0.3,11.4v0.2c-0.2,3.2-0.5,6.4-1,9.6c-0.9,4.9-2,6.2-2.7,6.4L452.8,184.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M453.9,149.9v0.7c-0.7,0.1-1.4,0.2-2.1,0.4c-1.3,0.3-3.2,0.7-6.3,1.3l-2.7,0.5c-1.6,0.2-1.6,0.3-1.8,0.5    c-1.3,1.2-1.3,3-1.3,6.2c0.1,3.9-0.2,7.8-0.8,11.7l-0.1,0.5c-0.3,1.9-0.6,3.8,0.1,5c0.3,0.5,0.6,0.6,1.6,0.8    c0.9,0.2,1.7,0.5,2.5,0.8c2,0.9,3.9,1.9,5.6,3.2l0,0c1.7,1.1,2.7,1.9,3.3,2.5c0.3,0.2,0.5,0.4,0.9,0.6h0.1    c0.5-0.1,1.6-0.9,2.5-6.1c0.5-3.2,0.8-6.3,1-9.5v-0.2c0.3-3.8,0.4-7.6,0.3-11.4c-0.1-1.4-0.3-2.8-0.7-4.2    c-0.2-0.9-0.7-1.7-1.5-2.2c-0.2-0.1-0.4-0.2-0.5-0.2L453.9,149.9 M453.9,150c0.3,0,0.6,0.1,0.9,0.3c3.2,2,2.7,10.4,2.2,18.4    c-0.3,4.5-1,15.8-4,16.5h-0.2c-0.7,0-1.1-0.9-4.5-3.2c-1.7-1.3-3.5-2.3-5.5-3.2c-2.7-1.1-3.7-0.7-4.5-1.9c-1-1.5-0.5-3.8-0.2-6    c1.9-11.2-0.5-15.6,2.3-18.2c0.5-0.5,0.7-0.4,4.9-1.1C451.2,150.5,453,149.9,453.9,150L453.9,150z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_218"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M421.5,178.6L421.5,178.6c-1.1-0.4-1.8-2.3-2.2-5.4c-0.4-2.9-0.4-5.9-0.3-8.9c0-0.1,0-0.3,0-0.4    c0.1-2.2,0.4-4.4,0.9-6.6c0.3-1.3,0.7-2.5,1.3-3.7c0.4-0.9,1.2-1.7,2.1-2.1c0.2-0.1,0.4-0.1,0.6-0.1c0.6,0.1,1.2,0.3,1.7,0.6    c0.7,0.3,1.7,0.8,3.1,1.3c1.8,0.7,3.7,1.1,5.7,1.4c0.8,0,1.6,0.3,2.3,0.7c0.9,0.7,1.4,2.4,1.6,5c0.3,3.6-0.1,9-1,16.2    c-1.4,0.3-2.8,0.5-4.3,0.6c-0.6,0.1-0.9,0.1-1.4,0.1s-1.2,0.1-2.7,0.2c-2,0.1-4,0.3-6,0.7c-0.6,0.1-1,0.2-1.2,0.3    C421.7,178.6,421.6,178.6,421.5,178.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M423.9,151.8L423.9,151.8c-0.2,0-0.3,0-0.5,0.1c-2.5,1-3.8,6.9-4.1,12c0,0.1,0,0.2,0,0.4    c-0.2,2.9-0.1,5.9,0.3,8.8c0.1,1.2,0.4,2.4,0.8,3.6c0.2,0.6,0.6,1.2,1.1,1.5l0.2,0c0.2-0.1,0.6-0.2,1.2-0.3c2-0.4,4-0.6,6-0.7    c1.5-0.1,2.2-0.1,2.7-0.2s0.8,0,1.4-0.1c1.3-0.1,2.7-0.3,4-0.6c0.9-7,1.3-12.4,1-15.9c-0.2-2.5-0.7-4.1-1.5-4.7    c-0.6-0.4-1.4-0.7-2.2-0.7c-2-0.3-3.9-0.7-5.7-1.4c-1.5-0.5-2.5-1-3.2-1.3C425,152.1,424.5,151.9,423.9,151.8 M424,151.1    c0.9,0,1.9,0.8,5,1.9c5.3,1.8,6.6,1,8.1,2.2s2.9,5.4,0.7,21.8c-1.5,0.3-3,0.5-4.5,0.7c-1.2,0.1-1.1,0.1-4.2,0.3    c-2,0.1-4,0.3-5.9,0.6c-1.1,0.3-1.4,0.4-1.6,0.4c-0.1,0-0.1,0-0.2,0c-2.5-0.9-2.9-9.3-2.7-14.6c0-0.2,0-0.4,0-0.4    c0.1-2.3,0.9-11.2,4.5-12.7C423.5,151.2,423.7,151.1,424,151.1L424,151.1z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_219",
    className: "st10",
    d: "M441.5,177.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_220",
    className: "st10",
    d: "M437.9,191"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221",
    className: "st10",
    d: "M440.2,173.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_222",
    className: "st10",
    d: "M431.5,195.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_223",
    className: "st10",
    d: "M439.1,174.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_224",
    className: "st10",
    d: "M449.7,181.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_225",
    className: "st10",
    d: "M439.1,142.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_226",
    className: "st10",
    d: "M437,178.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_227",
    className: "st10",
    d: "M426.3,176.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_228",
    className: "st10",
    d: "M442.3,162.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_229",
    className: "st10",
    d: "M428.1,151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_230",
    className: "st10",
    d: "M441.3,148.9c0.2,1.3-0.1,2.7-0.8,3.8c-0.8,0.6-1.6,1.1-2.5,1.6c-0.8,0.6-1.8,1-2.8,1.2   c-0.2,0-0.4,0-0.5,0c-1.8,0-3.5-1.1-6-2.4c-1.2-0.5-2.3-1.1-3.4-1.8c-0.6-0.3-1.2-0.8-1.7-1.3c-1.5-2.4,0.8-10,5.2-12.2   c2.6-1.3,5.3-0.3,6.6,0.2c1.5,0.5,2.8,1.4,3.7,2.7c0.6,0.8,1,1.7,1.3,2.6C441.1,145.1,441.4,147,441.3,148.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_231",
    className: "st10",
    d: "M449.9,141.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_232",
    className: "st10",
    d: "M454.3,144.2c-0.7-1.7-1.7-3.3-3-4.6c-1.2-1.5-2.7-2.8-4.3-3.8c-1.9-1.1-4-2.3-5.5-1   c-1.3,1-1.6,3.3-1.5,4.6s0.5,1.5,1.2,4.7c0.3,1.1,0.5,2.3,0.6,3.4c0.1,2.1-0.2,2.8,0.2,3.4s1.4,0.6,2.8,0.5   c0.7-0.1,1.4-0.2,2.1-0.4c2.2-0.5,1.4-0.3,3.5-0.7c4.1-1,4.4-1.3,4.6-1.5C455.6,147.6,454.8,145.5,454.3,144.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_233",
    className: "st11",
    d: "M452.7,131.3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_22",
    transform: "matrix(2.827062e-02 -0.9996 0.9996 2.827062e-02 234.7796 621.7377)",
    className: "st12",
    cx: 437.2,
    cy: 190.1,
    rx: 3.9,
    ry: 3
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_23",
    transform: "matrix(2.827062e-02 -0.9996 0.9996 2.827062e-02 269.39 608.9199)",
    className: "st12",
    cx: 447.9,
    cy: 165.9,
    rx: 3.9,
    ry: 3
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_24",
    transform: "matrix(2.827062e-02 -0.9996 0.9996 2.827062e-02 250.1993 590.4596)",
    className: "st12",
    cx: 428.8,
    cy: 166.5,
    rx: 3.9,
    ry: 3
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_25",
    transform: "matrix(2.827062e-02 -0.9996 0.9996 2.827062e-02 273.8205 574.2767)",
    className: "st12",
    cx: 432.3,
    cy: 146.3,
    rx: 3.9,
    ry: 3
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_26",
    transform: "matrix(2.844498e-02 -0.9996 0.9996 2.844498e-02 290.6505 587.6647)",
    className: "st12",
    cx: 447.6,
    cy: 144.3,
    rx: 3.9,
    ry: 3
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_234",
    className: "st12",
    d: "M524.3,129.2"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "Path_235",
    className: "st10",
    d: "M754.1,254.3"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "Path_236",
    className: "st10",
    d: "M756.7,239.2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237",
    className: "st10",
    d: "M755.8,262.1"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_53"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_27"
  }, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.3236 -0.9462 0.9462 0.3236 280.1653 869.1113)",
    className: "st6",
    cx: 748,
    cy: 238.6,
    rx: 34.5,
    ry: 26.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.3241 -0.946 0.946 0.3241 279.8022 868.9566)",
    className: "st7",
    cx: 748,
    cy: 238.7,
    rx: 34.1,
    ry: 26
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_238"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M743.4,270.2c-1.6,0-3.2-0.2-4.7-0.6c-2-0.5-3.9-1.2-5.6-2.2c-2.8-1.5-5-3.8-6.4-6.6c-1-2.3-1.5-4.8-1.3-7.4    c0.2-2.6,1.1-4.5,2.5-5.5s3.9-1.2,6.4-1.3c0.5,0,1,0,1.6,0c1,0,2,0.1,3,0.1l0,0c1.5,0,2.9,0.2,4.4,0.4c1.8,0.4,3.4,1.1,5,2    l0.4,0.2c5.2,2.8,8.5,4.5,10.9,5.9c1.3,0.7,2.2,1.3,2.8,1.7c0.8,0.6,0.9,0.8,0.9,0.8c0.2,1.1-0.3,2.6-1.5,4.1    c-2,2.4-4.6,4.3-7.4,5.7C750.9,269.3,747.2,270.2,743.4,270.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M743.4,269.9c3.7-0.1,7.4-1,10.7-2.6c2.8-1.3,5.3-3.2,7.3-5.6c1.1-1.4,1.7-2.8,1.5-3.8    c-0.3-0.3-0.6-0.6-1-0.8c-0.6-0.4-1.6-1-2.8-1.7c-2.4-1.3-5.7-3.1-10.6-5.7l-0.4-0.2c-1.5-0.9-3.2-1.5-4.9-1.9    c-1.4-0.3-2.9-0.4-4.3-0.4l0,0c-1,0-2-0.1-3-0.1c-0.5,0-1,0-1.5,0c-2.4,0.1-4.8,0.3-6.2,1.3s-2.2,2.8-2.4,5.3    c-0.2,2.5,0.3,4.9,1.3,7.2c1.3,2.8,3.5,5,6.3,6.5c1.7,1,3.6,1.7,5.5,2.2C740.3,269.7,741.9,269.9,743.4,269.9 M743.4,270.6    c-1.6,0-3.2-0.2-4.8-0.6c-1.9-0.5-9.3-2.5-12.3-9c-2.1-4.6-2-11.1,1.3-13.3c1.6-1.1,4-1.2,6.5-1.4c0.5,0,1.1,0,1.6,0    c1,0,2,0.1,3,0.1c1.5,0,3,0.2,4.4,0.5c2,0.4,3.8,1.2,5.5,2.2c9.7,5.1,14.6,7.7,14.8,8.7C764.5,262.2,754.3,270.6,743.4,270.6    L743.4,270.6z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_239",
    className: "st10",
    d: "M733.9,244.8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Path_240"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M726,247c-0.2,0-0.4-0.1-0.6-0.2c-0.7-0.7-1.2-1.6-1.1-2.6c-0.1-1.5,0.1-3,0.4-4.5c0.6-3.1,1.5-6.1,2.5-9    l0.1-0.2l0,0c1.1-3.5,2.4-7,4-10.4c0.6-1.3,1.4-2.4,2.4-3.5c0.7-0.8,1.7-1.3,2.8-1.4h0.2c0.7,0,1.3,0.3,3.2,1.6    c1.4,0.9,3.4,2.2,6.7,4.2l2.9,1.8c1.7,1,1.9,1.1,2.1,1.5c1.1,1.9,0.4,3.5-0.9,6.4c-1.6,3.5-2.8,7.1-3.5,10.9l-0.1,0.5    c-0.3,1.9-0.7,3.8-2.2,4.5c-0.3,0.1-0.6,0.2-0.9,0.2c-0.5,0-1.1-0.1-1.6-0.3c-1-0.2-2.1-0.4-3.1-0.5c-0.8-0.1-1.6-0.1-2.5-0.1    c-1.4,0-2.8,0.1-5,0.3l0,0c-2.4,0.2-3.8,0.4-4.7,0.5C726.8,247,726.4,247,726,247z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M736.6,215.6h-0.1c-1.8,0.1-3.4,1.6-4.9,4.6c-1.6,3.3-2.9,6.8-4,10.3l0,0l-0.1,0.2c-1,2.9-1.9,5.9-2.5,9    c-0.3,1.4-0.4,2.9-0.4,4.4c0,0.9,0.3,1.7,1,2.3c0.1,0.1,0.3,0.1,0.4,0.1c0.4,0,0.7-0.1,1.1-0.1c0.9-0.1,2.3-0.4,4.7-0.5l0,0    c2.1-0.2,3.7-0.3,5-0.3c0.8,0,1.7,0,2.5,0.1c1.1,0.1,2.1,0.3,3.2,0.5c0.5,0.1,1,0.2,1.5,0.2c0.3,0,0.5-0.1,0.8-0.2    c1.3-0.6,1.6-2.4,2-4.3l0.1-0.5c0.7-3.8,1.9-7.4,3.5-10.9c0.6-1.1,1-2.3,1.3-3.5c0.2-0.9,0.1-1.8-0.4-2.5c-0.2-0.4-0.3-0.4-2-1.4    c-0.7-0.4-1.6-1-2.9-1.8c-3.3-2-5.3-3.3-6.7-4.2C737.6,215.9,737.1,215.6,736.6,215.6 M736.6,214.9c1.4,0,2,1,10,5.9    c4.5,2.8,4.7,2.7,5.2,3.4c2.2,3.7-2.2,6.5-4.3,17.5c-0.4,2.1-0.7,4.4-2.5,5.3c-0.3,0.2-0.7,0.3-1.1,0.2c-1,0-2.2-0.5-4.7-0.8    c-0.8-0.1-1.6-0.1-2.4-0.1c-1.4,0-2.8,0.1-5,0.3c-3.8,0.3-5.1,0.7-5.9,0.7c-0.3,0-0.5-0.1-0.8-0.2c-3.2-2.1,0.3-12.6,1.7-16.8    c2.5-7.5,5-15.2,9.5-15.4H736.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_241"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M764,257h-0.2c-0.2,0-0.2,0-0.5-0.3s-0.6-0.5-1.2-0.9c-2.1-1.3-4.3-2.5-6.5-3.5c-1.7-0.8-2.5-1.2-3-1.5    s-0.9-0.4-1.6-0.8c-1.6-0.9-3.2-1.8-4.7-2.7c1.6-6.9,3.3-12,5-15c1.2-2.3,2.5-3.5,3.7-3.6c0.2,0,0.3,0,0.5,0    c0.8,0.1,1.7,0.2,2.5,0.5c2.3,0.7,4.6,1.3,7,1.6c1.8,0.3,3.1,0.4,4.1,0.4c1.6,0.1,2.1,0.2,2.9,0.8c3.4,2.9,1.1,10.8,0.3,13.2l0,0    l-0.1,0.3c-0.9,2.6-2.1,5.2-3.5,7.6C766.8,255.6,765.3,257,764,257z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M755.5,228.9c-0.2,0-0.3,0-0.5,0c-0.6,0.1-1.1,0.4-1.5,0.8c-0.8,0.8-1.5,1.7-2,2.7c-1.7,3-3.3,7.9-4.9,14.7    c1.4,0.9,2.9,1.8,4.4,2.6c0.7,0.4,1,0.5,1.6,0.8s1.4,0.7,3,1.5c2.3,1.1,4.5,2.2,6.6,3.6c0.7,0.5,1,0.7,1.3,0.9    c0.1,0.1,0.2,0.1,0.3,0.2l0,0h0.2c1.1,0,2.6-1.4,4.2-3.8c1.4-2.4,2.6-4.9,3.5-7.5l0.1-0.4l0,0c0.7-2,1.2-4.1,1.4-6.3    c0.2-1.3,0.1-2.6-0.1-3.8c-0.2-1-0.7-2-1.5-2.7c-0.6-0.5-1.1-0.6-2.7-0.7c-0.9-0.1-2.2-0.2-4.1-0.4c-2.4-0.3-4.7-0.9-7-1.6    C757,229.1,756.2,228.9,755.5,228.9 M755.4,228.1c1.8,0,3.4,1.2,9.5,2.1c4.9,0.7,5.8,0.2,7.1,1.3c3.7,3.1,1.1,11.5,0.4,13.6    l-0.1,0.4c-1.7,4.8-5.2,11.8-8.3,11.8h-0.3c-0.4-0.1-0.3-0.2-1.8-1.2c-2.1-1.3-4.3-2.5-6.5-3.5c-3.4-1.7-3.3-1.6-4.7-2.3    c-2.1-1.1-3.8-2.2-4.9-2.9c3.7-15.7,6.9-18.9,9.1-19.2C755.1,228.2,755.3,228.2,755.4,228.1L755.4,228.1z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_242",
    className: "st10",
    d: "M741.3,246"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_243",
    className: "st10",
    d: "M740.2,259.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_244",
    className: "st10",
    d: "M744.2,243.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_245",
    className: "st10",
    d: "M745.6,267.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_246",
    className: "st10",
    d: "M745,244.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_247",
    className: "st10",
    d: "M730.4,245.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_248",
    className: "st10",
    d: "M757.2,216.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_249",
    className: "st10",
    d: "M746.2,248.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_250",
    className: "st10",
    d: "M759.2,252.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_251",
    className: "st10",
    d: "M746,232.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_252",
    className: "st10",
    d: "M766.6,228.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_253",
    className: "st10",
    d: "M752.3,220.4c-0.7,1.1-0.9,2.5-0.5,3.8c0.7,0.9,1.4,1.8,2.2,2.7c0.7,1,1.7,1.8,2.8,2.5   c0.3,0.1,0.5,0.2,0.6,0.3c2,0.8,4.5,0.7,7.7,0.8c1.5,0.1,3.1,0.1,4.6,0.1c0.8,0,1.7-0.1,2.4-0.4c2.6-1.4,3-9.4-1.3-13.5   c-2.5-2.5-5.9-2.9-7.6-3.1c-1.8-0.3-3.6-0.1-5.3,0.5c-0.9,0.4-1.8,1-2.5,1.7C754,217.1,753,218.7,752.3,220.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_254",
    className: "st10",
    d: "M745.2,210"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_255",
    className: "st10",
    d: "M739.3,209.8c1.5-1.2,3.3-2.1,5.2-2.6c2-0.8,4.2-1.2,6.4-1.2c2.5,0,5.4,0,6.7,1.8   c1.1,1.5,0.5,3.8,0,4.9s-1.2,1.1-3.2,3.6c-0.8,0.9-1.4,1.8-2,2.8c-0.9,1.8-0.8,2.6-1.6,3s-1.8-0.1-3.3-0.9   c-0.8-0.4-1.5-0.8-2.2-1.4c-2.3-1.5-1.5-0.9-3.7-2.4c-4.4-2.9-4.5-3.3-4.6-3.7C736.5,212.2,738.2,210.8,739.3,209.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_256",
    className: "st11",
    d: "M746.1,199.1"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_28",
    transform: "matrix(0.9984 -5.634428e-02 5.634428e-02 0.9984 -13.4469 42.1814)",
    className: "st13",
    cx: 741.3,
    cy: 259.6,
    rx: 3.7,
    ry: 3.8
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_29",
    transform: "matrix(0.9984 -5.634428e-02 5.634428e-02 0.9984 -11.929 41.9679)",
    className: "st13",
    cx: 738.3,
    cy: 232.5,
    rx: 3.7,
    ry: 3.8
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_30",
    transform: "matrix(0.9984 -5.634428e-02 5.634428e-02 0.9984 -12.4603 43.1992)",
    className: "st13",
    cx: 759.9,
    cy: 242.6,
    rx: 3.7,
    ry: 3.8
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_31",
    transform: "matrix(0.9984 -5.634428e-02 5.634428e-02 0.9984 -11.3345 43.3764)",
    className: "st13",
    cx: 763.6,
    cy: 222.7,
    rx: 3.7,
    ry: 3.8
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_32",
    transform: "matrix(1.780136e-02 -0.9998 0.9998 1.780136e-02 520.3272 956.0712)",
    className: "st12",
    cx: 746.8,
    cy: 213.2,
    rx: 3.8,
    ry: 3.7
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_257",
    className: "st10",
    d: "M685.7,202.6"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_258",
    className: "st10",
    d: "M683,216.2"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_259",
    className: "st10",
    d: "M683.7,195.1"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_54"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_33"
  }, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.3816 -0.9243 0.9243 0.3816 231.0903 783.1301)",
    className: "st6",
    cx: 700.8,
    cy: 218.9,
    rx: 34.7,
    ry: 24.6
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.3819 -0.9242 0.9242 0.3819 230.9101 782.9384)",
    className: "st7",
    cx: 700.8,
    cy: 218.8,
    rx: 34.4,
    ry: 24.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_260"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M713.6,211.3c-1.2,0-2.4-0.1-3.6-0.2l0,0c-1.4-0.1-2.8-0.3-4.1-0.6c-1.6-0.4-3.2-1.2-4.6-2.1l-0.4-0.2    c-4.7-2.9-7.7-4.8-9.8-6.2c-0.9-0.6-1.7-1.2-2.5-1.8c-0.7-0.6-0.8-0.8-0.8-0.8c-0.1-1.1,0.5-2.6,1.9-4.2    c4.5-4.7,10.7-7.5,17.2-7.7c1.7,0,3.4,0.2,5,0.7c1.8,0.5,3.5,1.3,5.1,2.4c2.6,1.6,4.5,3.9,5.5,6.8c0.8,2.4,1,4.9,0.7,7.4    c-0.4,2.6-1.4,4.5-2.9,5.4s-3.7,1.1-6.1,1.1L713.6,211.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M707,187.9c-6.4,0.2-12.6,2.9-17,7.6c-1.2,1.5-1.9,2.8-1.8,3.8c0.3,0.3,0.6,0.6,0.9,0.8    c0.6,0.5,1.4,1,2.5,1.8c2.1,1.4,5.2,3.3,9.6,6l0.4,0.2c1.4,0.9,2.9,1.6,4.5,2.1c1.3,0.3,2.7,0.5,4,0.6l0,0    c1.1,0.1,2.3,0.2,3.5,0.2h0.7c2.3-0.1,4.5-0.1,5.9-1.1s2.3-2.7,2.7-5.2c0.4-2.4,0.1-4.9-0.7-7.2c-1-2.7-2.9-5.1-5.4-6.6    c-1.6-1-3.3-1.8-5-2.3C710.3,188.1,708.6,187.9,707,187.9 M707,187.2c1.7,0,3.4,0.2,5.1,0.7c1.7,0.5,8.6,2.7,10.9,9.3    c1.6,4.6,1,11.1-2.3,13.2c-1.6,1-3.9,1.1-6.3,1.2h-0.7c-1.3,0-2.5-0.1-3.6-0.2c-1.4-0.1-2.8-0.3-4.2-0.6c-1.8-0.5-3.5-1.3-5-2.4    c-8.8-5.4-13.2-8.1-13.3-9.1C687,195,696.9,187.2,707,187.2L707,187.2z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_261",
    className: "st10",
    d: "M714.6,213.1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Path_262"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M709.7,242.4c-0.7,0-1.1-0.3-3-1.7c-1.2-0.9-3-2.3-6-4.4c-1.2-0.8-2-1.4-2.6-1.9c-1.6-1.1-1.7-1.2-1.8-1.6    c-0.9-1.9-0.1-3.5,1.3-6.4c1.8-3.4,3.2-7,4.1-10.7c0-0.2,0.1-0.3,0.1-0.5c0.5-1.9,1-3.8,2.4-4.5c0.3-0.1,0.5-0.2,0.8-0.2    c0.5,0,1,0.1,1.5,0.3c1,0.3,1.9,0.5,2.9,0.6c1.1,0.2,2.1,0.2,3.2,0.2c1.1,0,2.3-0.1,3.9-0.1c2.2-0.1,3.6-0.3,4.5-0.4    c0.3-0.1,0.7-0.1,1-0.1c0.2,0,0.4,0,0.6,0.2c0.7,0.7,1,1.7,0.8,2.6c-0.1,1.5-0.3,3-0.7,4.5c-0.9,3-1.9,6-3.1,8.9l-0.1,0.2    c-1.3,3.5-2.8,6.9-4.6,10.2C713.2,240.9,711.4,242.4,709.7,242.4L709.7,242.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M709.7,242.1L709.7,242.1c1.7,0,3.4-1.5,5.1-4.5c1.8-3.3,3.3-6.7,4.6-10.2l0.1-0.2c1.2-2.9,2.2-5.9,3.1-8.9    c0.4-1.4,0.6-2.9,0.7-4.4c0.1-0.8-0.1-1.7-0.7-2.3c-0.1-0.1-0.2-0.1-0.4-0.1c-0.3,0-0.7,0-1,0.1c-1.5,0.2-3,0.3-4.5,0.4    c-1.6,0.1-2.8,0.1-3.9,0.1c-1.1,0-2.2-0.1-3.2-0.2c-1-0.2-2-0.4-3-0.6c-0.5-0.2-0.9-0.3-1.4-0.3c-0.2,0-0.5,0.1-0.7,0.2    c-1.3,0.6-1.8,2.4-2.2,4.2c0,0.2-0.1,0.3-0.1,0.5c-1,3.7-2.4,7.3-4.2,10.8c-0.6,1.1-1.1,2.3-1.5,3.5c-0.3,0.8-0.2,1.7,0.2,2.5    c0.2,0.3,0.2,0.4,1.7,1.4c0.6,0.4,1.5,1,2.6,1.9c2.9,2.1,4.8,3.5,6,4.4C708.8,241.8,709.1,242.1,709.7,242.1 M709.7,242.8    c-1.4,0-1.7-0.9-9.1-6.2c-4-2.9-4.3-2.8-4.6-3.6c-1.7-3.8,2.6-6.4,5.5-17.3c0.5-2.1,1-4.4,2.7-5.2c0.3-0.2,0.7-0.2,1-0.2    c1,0,2,0.6,4.5,0.9c1,0.2,2.1,0.2,3.1,0.2c1.1,0,2.3-0.1,3.9-0.1c3.5-0.2,4.8-0.5,5.5-0.5c0.3,0,0.6,0.1,0.8,0.2    c2.9,2.2-1.3,12.5-3,16.6c-2.9,7.4-6,15-10.2,15L709.7,242.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_263"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M693,228.7c-0.8-0.1-1.6-0.3-2.4-0.6c-2.1-0.8-4.3-1.4-6.5-1.8c-1.7-0.3-2.9-0.5-3.8-0.5    c-1.5-0.2-2-0.2-2.6-0.8c-3-3-0.2-10.8,0.8-13.2v-0.1c0-0.1,0.1-0.2,0.1-0.3c1.1-2.6,2.4-5.1,3.9-7.4c1.7-2.5,3.3-3.9,4.5-3.9h0.3    c0.1,0,0.1,0,0.4,0.3s0.5,0.5,1.1,0.9c1.9,1.4,3.9,2.6,5.9,3.7l2.8,1.6c0.5,0.3,0.8,0.5,1.5,0.9c1.4,0.9,2.8,1.9,4.2,2.9    c-2.1,6.8-4.1,11.8-5.9,14.8c-1.4,2.2-2.6,3.4-3.8,3.5L693,228.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M693,228.3h0.4c1.1-0.1,2.3-1.3,3.6-3.4c1.8-2.9,3.8-7.8,5.8-14.5c-1.3-0.9-2.6-1.8-4-2.7    c-0.6-0.4-0.9-0.5-1.4-0.9s-1.3-0.7-2.8-1.6c-2.1-1.1-4-2.4-5.9-3.8c-0.6-0.5-0.9-0.8-1.1-0.9c-0.1-0.1-0.1-0.1-0.2-0.2l0,0H687    c-0.6,0-2,0.5-4.2,3.7c-1.5,2.3-2.8,4.8-3.9,7.4c0,0.1-0.1,0.2-0.1,0.3v0.1c-0.8,2-1.4,4.1-1.8,6.2c-0.2,1.3-0.3,2.5-0.2,3.8    c0.1,1,0.5,2,1.2,2.8c0.5,0.5,0.9,0.6,2.4,0.7c0.9,0.1,2.1,0.2,3.8,0.6c2.2,0.4,4.4,1,6.5,1.8C691.4,228.1,692.2,228.3,693,228.3     M693,229.1c-1.8,0-3.1-1.3-8.9-2.4c-4.6-0.9-5.5-0.4-6.6-1.5c-3.2-3.2-0.1-11.4,0.7-13.5l0.2-0.4c1.9-4.6,5.7-11.5,8.7-11.5    c0.1,0,0.2,0,0.3,0c0.4,0.1,0.3,0.2,1.7,1.2c1.9,1.4,3.8,2.6,5.9,3.7c3.1,1.8,3,1.7,4.2,2.5c1.9,1.2,3.4,2.3,4.4,3    c-4.8,15.5-8,18.5-10.1,18.8C693.3,229,693.1,229,693,229.1L693,229.1z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_264",
    className: "st10",
    d: "M707.7,211.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_265",
    className: "st10",
    d: "M709.8,197.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_266",
    className: "st10",
    d: "M704.7,214.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_267",
    className: "st10",
    d: "M705.3,190.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_268",
    className: "st10",
    d: "M704.1,212.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_269",
    className: "st10",
    d: "M718,212.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_270",
    className: "st10",
    d: "M690.3,240.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_271",
    className: "st10",
    d: "M703.3,208.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_272",
    className: "st10",
    d: "M691.3,204.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_273",
    className: "st10",
    d: "M702.1,225.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_274",
    className: "st10",
    d: "M682.4,227.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275",
    className: "st10",
    d: "M695.3,236.8c0.8-1.1,1.1-2.5,0.8-3.8c-0.6-1-1.2-1.9-1.9-2.7c-0.6-1-1.5-1.8-2.4-2.5   c-0.2-0.1-0.4-0.2-0.6-0.3c-1.9-0.9-4.2-0.9-7.2-1.1c-1.4-0.2-2.9-0.2-4.3-0.2c-0.8,0-1.6,0.1-2.3,0.3c-2.6,1.3-3.5,9.2,0.2,13.5   c2.2,2.5,5.4,3,6.9,3.3c2.7,0.6,5.5-0.1,7.5-2C693.3,240,694.5,238.5,695.3,236.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276",
    className: "st10",
    d: "M701.1,247.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_277",
    className: "st10",
    d: "M706.7,247.8c-1.5,1.2-3.3,2-5.1,2.4c-2,0.7-4,1-6.1,1c-2.4-0.1-5.1-0.1-6.2-2   c-0.9-1.6-0.2-3.8,0.4-4.9s1.2-1,3.3-3.5c0.8-0.8,1.5-1.7,2.1-2.7c1-1.8,1-2.6,1.7-2.9s1.7,0.2,3.1,1c0.7,0.4,1.4,0.9,2,1.4   c2.1,1.6,1.4,1,3.3,2.5c3.9,3,4,3.4,4.1,3.8C709.5,245.5,707.8,246.9,706.7,247.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_278",
    className: "st11",
    d: "M699.5,258.2"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_34",
    transform: "matrix(0.2907 -0.9568 0.9568 0.2907 312.9884 818.7772)",
    className: "st12",
    cx: 708.7,
    cy: 198.3,
    rx: 3.8,
    ry: 3.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_35",
    transform: "matrix(0.2907 -0.9568 0.9568 0.2907 287.6644 838.6218)",
    className: "st12",
    cx: 709.5,
    cy: 225.3,
    rx: 3.8,
    ry: 3.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_36",
    transform: "matrix(0.2907 -0.9568 0.9568 0.2907 283.9791 812.3217)",
    className: "st12",
    cx: 689.9,
    cy: 214.6,
    rx: 3.8,
    ry: 3.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_37",
    transform: "matrix(0.2907 -0.9568 0.9568 0.2907 261.533 821.4202)",
    className: "st12",
    cx: 684.8,
    cy: 234.3,
    rx: 3.8,
    ry: 3.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_38",
    transform: "matrix(0.299 -0.9542 0.9542 0.299 257.5674 838.9733)",
    className: "st12",
    cx: 699.8,
    cy: 244.2,
    rx: 3.8,
    ry: 3.5
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_55"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_39"
  }, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(1.047176e-02 -0.9999 0.9999 1.047176e-02 311.315 643.9209)",
    className: "st6",
    cx: 481,
    cy: 164.7,
    rx: 36.9,
    ry: 23.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(1.047176e-02 -0.9999 0.9999 1.047176e-02 311.325 643.911)",
    className: "st7",
    cx: 481,
    cy: 164.7,
    rx: 36.5,
    ry: 22.9
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_279"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M480.1,154.6c-0.8,0-1.7-0.1-2.5-0.2l-0.4-0.1c-5.2-0.7-8.5-1.2-10.9-1.6c-0.9-0.2-1.9-0.4-2.8-0.6    c-0.9-0.3-1-0.5-1-0.5c-0.9-1.6-0.3-4.9,1.4-8.4c1.5-3.1,3.6-5.9,6.2-8.3c1.3-1.2,2.7-2.2,4.3-3.1c1.5-0.8,3.2-1.4,4.9-1.7    c0.9-0.1,1.9-0.2,2.8-0.2c3.8-0.1,7.4,1.4,9.8,4.3c1.6,2,2.8,4.3,3.3,6.8c0.6,2.7,0.5,5-0.5,6.6s-2.9,2.7-4.9,3.8    c-1.2,0.7-2.5,1.2-3.8,1.7l0,0c-1.2,0.5-2.5,1-3.8,1.3C481.6,154.5,480.9,154.6,480.1,154.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M482.1,130.2c-0.9,0-1.8,0.1-2.7,0.2c-1.7,0.3-3.3,0.8-4.8,1.6c-1.5,0.8-3,1.9-4.2,3    c-2.5,2.3-4.6,5.1-6.1,8.2c-0.8,1.5-1.3,3.2-1.7,4.9c-0.3,1.1-0.2,2.2,0.2,3.2c0.3,0.2,0.7,0.3,1.1,0.4c0.7,0.2,1.6,0.4,2.8,0.6    c2.4,0.4,5.7,0.9,10.5,1.5l0.4,0.1c0.8,0.1,1.6,0.2,2.4,0.2c0.7,0,1.5-0.1,2.2-0.2c1.3-0.3,2.5-0.7,3.7-1.2l0,0    c1.3-0.5,2.5-1,3.7-1.7c2-1.1,3.9-2.1,4.8-3.7s1-3.7,0.4-6.3c-0.6-2.4-1.7-4.7-3.2-6.7c-1.3-1.5-3-2.7-4.8-3.4    C485.3,130.5,483.7,130.2,482.1,130.2 M482.1,129.5c3.9-0.1,7.6,1.5,10.1,4.4c3.1,3.7,5,10.3,2.9,13.8c-1,1.7-3,2.8-5,3.9    c-1.2,0.7-2.5,1.2-3.8,1.7c-1.2,0.5-2.5,1-3.8,1.3c-0.8,0.2-1.5,0.2-2.3,0.2c-1,0-2-0.1-3-0.3c-9.6-1.3-14.5-2-14.9-2.8    c-2.4-4.7,5.7-20.2,17-22C480.2,129.6,481.2,129.5,482.1,129.5L482.1,129.5z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_280",
    className: "st10",
    d: "M490.9,153"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Path_281"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M496.9,183.6c-0.8-0.1-1.7-0.3-2.5-0.5c-1.4-0.4-3.5-0.9-6.8-1.6c-1.3-0.3-2.3-0.5-3-0.6    c-1.8-0.4-1.9-0.4-2.2-0.7c-1.5-1.5-1.4-3.3-1.2-6.8c0.3-4.1,0.1-8.1-0.4-12.2c0-0.2,0-0.4-0.1-0.5c-0.3-2-0.6-4.1,0.5-5.4    c0.5-0.6,1-0.7,2-0.9c0.9-0.2,1.9-0.4,2.8-0.7c2.2-0.8,4.3-1.8,6.2-3.1l0,0c1.3-0.7,2.5-1.5,3.7-2.4c0.6-0.5,1-0.7,1.2-0.7h0.2    c1.6,0.4,2.4,3.9,2.7,6.8c0.4,3.3,0.6,6.7,0.6,10v0.3c0.2,4,0.1,7.9-0.2,11.9c-0.4,3.8-1.4,6-2.9,6.9    C497.4,183.5,497.1,183.6,496.9,183.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M496.9,183.3c0.2,0,0.4-0.1,0.6-0.2c1.4-0.8,2.3-2.9,2.7-6.6c0.3-3.9,0.4-7.9,0.2-11.9v-0.3    c0-3.3-0.2-6.7-0.6-10c-0.2-1.5-0.5-3.1-1-4.5c-0.4-1.1-0.9-1.8-1.5-1.9h-0.1c-0.4,0.1-0.7,0.3-1,0.6c-0.7,0.5-1.8,1.3-3.8,2.4    l0,0c-2,1.3-4.1,2.3-6.3,3.1c-0.9,0.3-1.9,0.5-2.8,0.7c-1.1,0.2-1.5,0.3-1.9,0.8c-0.9,1.2-0.6,3.2-0.4,5.1c0,0.2,0,0.4,0.1,0.5    c0.5,4.1,0.7,8.2,0.4,12.2c-0.2,3.3-0.3,5.1,1.1,6.5c0.2,0.2,0.3,0.3,2,0.6l3,0.6c3.3,0.7,5.4,1.2,6.8,1.6    C495.3,183,496.1,183.2,496.9,183.3 M496.9,184c-1.1,0-2.9-0.8-9.4-2.1c-4.6-1-4.8-0.8-5.3-1.4c-2.9-2.9-0.1-7.3-1.7-19.1    c-0.3-2.3-0.8-4.7,0.5-6.2c0.9-1.2,2-0.7,5-1.7c2.1-0.8,4.2-1.8,6.1-3c3.8-2.2,4.4-3.1,5.1-3.1c0.1,0,0.2,0,0.3,0    c3.3,0.9,3.5,12.7,3.6,17.4c0.2,8.4,0.4,17.1-3.3,19.1C497.6,183.9,497.2,184,496.9,184L496.9,184z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_282"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M463.9,180.9c-0.2,0-0.5-0.1-0.7-0.2c-1-0.5-1.8-1.3-2.2-2.3c-0.6-1.2-1-2.5-1.3-3.9    c-0.4-2.3-0.7-4.6-0.7-6.9v-0.4c0-3.1,0.2-6.2,0.7-9.2c0.2-1.3,0.6-2.6,1.1-3.8c0.3-0.8,0.8-1.4,1.5-1.7h0.1    c0.1,0,0.2,0.1,0.3,0.1c0.2,0.1,0.6,0.2,1.3,0.4c2.1,0.5,4.3,0.8,6.5,1c1.6,0.2,2.5,0.3,3,0.3s0.9,0.1,1.6,0.2    c1.6,0.2,3.1,0.5,4.7,0.9c0.7,7.5,0.9,13.2,0.4,17c-0.4,2.8-1,4.4-2,5.1c-0.8,0.5-1.7,0.7-2.6,0.7c-2.1,0.2-4.2,0.6-6.3,1.2    c-1.6,0.5-2.7,0.9-3.5,1.2C465.2,180.8,464.6,180.9,463.9,180.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M463.9,180.6c0.6-0.1,1.2-0.2,1.7-0.5c0.8-0.3,1.9-0.7,3.5-1.2c2.1-0.6,4.2-1,6.4-1.2c0.9,0,1.7-0.2,2.5-0.6    c0.9-0.6,1.5-2.2,1.9-4.9c0.5-3.6,0.4-9.2-0.3-16.6c-1.5-0.3-2.9-0.6-4.4-0.8c-0.7-0.1-1-0.1-1.6-0.2s-1.4-0.1-3-0.3    c-2.2-0.2-4.4-0.5-6.6-1c-0.7-0.2-1.1-0.3-1.3-0.4l-0.2-0.1l0,0c-1,0.3-1.8,2.2-2.4,5.2c-0.5,3-0.8,6.1-0.7,9.2v0.4    c0,2.3,0.3,4.6,0.7,6.9c0.2,1.3,0.7,2.6,1.2,3.8c0.4,0.9,1.1,1.7,2,2.1C463.5,180.5,463.7,180.6,463.9,180.6 M463.9,181.3    c-0.3,0-0.6-0.1-0.8-0.2c-4-1.6-4.4-11-4.4-13.4c0,0,0-0.2,0-0.4c-0.1-5.5,0.8-14.2,3.6-15.1h0.2c0.2,0,0.5,0.2,1.7,0.5    c2.1,0.5,4.3,0.8,6.5,1c3.4,0.4,3.2,0.3,4.6,0.5c2.1,0.3,3.8,0.7,5,1c1.6,17.1,0,21.5-1.8,22.6s-3.1,0.2-9,1.9    C466,180.5,464.9,181.3,463.9,181.3L463.9,181.3z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_283",
    className: "st10",
    d: "M484.4,154.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_284",
    className: "st10",
    d: "M481.1,140.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_285",
    className: "st10",
    d: "M482.8,158.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_286",
    className: "st10",
    d: "M474.3,135"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_287",
    className: "st10",
    d: "M481.7,157.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_288",
    className: "st10",
    d: "M493.6,150.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_289",
    className: "st10",
    d: "M480.1,190.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_290",
    className: "st10",
    d: "M479.4,153.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_291",
    className: "st10",
    d: "M467.6,155.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_292",
    className: "st10",
    d: "M484.6,170.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_293",
    className: "st10",
    d: "M468.4,181.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_294",
    className: "st10",
    d: "M482.9,184.5c0.3-1.4,0-2.8-0.7-4c-0.8-0.7-1.7-1.3-2.6-1.8c-0.9-0.7-1.9-1.2-3-1.4   c-0.2,0-0.4,0-0.6,0c-2,0-3.9,1-6.7,2.2c-1.3,0.5-2.6,1.1-3.8,1.7c-0.7,0.3-1.4,0.8-1.9,1.3c-1.8,2.4,0.4,10.5,5.2,12.9   c2.9,1.5,5.8,0.5,7.2,0.1c1.6-0.4,3.1-1.3,4.2-2.6c0.7-0.8,1.2-1.7,1.5-2.6C482.5,188.4,482.9,186.5,482.9,184.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_295",
    className: "st10",
    d: "M492,192.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_296",
    className: "st10",
    d: "M496.9,190c-0.9,1.8-2.1,3.3-3.6,4.6c-1.4,1.5-3.1,2.8-4.9,3.7c-2.1,1-4.5,2.2-6.1,0.8   c-1.4-1.1-1.6-3.5-1.5-4.9s0.6-1.5,1.6-4.9c0.4-1.2,0.6-2.3,0.8-3.5c0.2-2.1-0.1-2.9,0.4-3.5s1.5-0.6,3-0.4   c0.8,0.1,1.5,0.2,2.3,0.5c2.4,0.6,1.5,0.3,3.8,0.9c4.5,1.2,4.8,1.5,5,1.8C498.5,186.5,497.5,188.6,496.9,190z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_297",
    className: "st11",
    d: "M494.5,203.3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_40",
    transform: "matrix(9.250091e-03 -1 1 9.250091e-03 334.5435 620.1635)",
    className: "st12",
    cx: 480.2,
    cy: 141.3,
    rx: 4,
    ry: 3.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_41",
    transform: "matrix(9.250091e-03 -1 1 9.250091e-03 319.3749 656.3312)",
    className: "st12",
    cx: 490.9,
    cy: 167,
    rx: 4,
    ry: 3.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_42",
    transform: "matrix(9.250091e-03 -1 1 9.250091e-03 300.1604 633.807)",
    className: "st12",
    cx: 469.9,
    cy: 165.4,
    rx: 4,
    ry: 3.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_43",
    transform: "matrix(9.250091e-03 -1 1 9.250091e-03 281.7938 657.7632)",
    className: "st12",
    cx: 472.8,
    cy: 186.7,
    rx: 4,
    ry: 3.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_44",
    transform: "matrix(9.250091e-03 -1 1 9.250091e-03 295.577 677.2883)",
    className: "st12",
    cx: 489.6,
    cy: 189.5,
    rx: 4.1,
    ry: 3.3
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_57"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_56"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_45"
  }, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1965 -0.9805 0.9805 0.1965 331.7392 805.6278)",
    className: "st6",
    cx: 657.4,
    cy: 200.4,
    rx: 35.4,
    ry: 22.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1966 -0.9805 0.9805 0.1966 331.6255 805.581)",
    className: "st7",
    cx: 657.4,
    cy: 200.4,
    rx: 35,
    ry: 22
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_298",
    className: "st10",
    d: "M671.5,195.7c-0.5,2.1-2.4,3-5,4.3c-2.9,1.5-4.8,2.4-6.7,1.5c-2.1-1.1-2.9-4-3.5-6.3   s-1.5-5.7,0.1-8.1c1-1.5,2.6-1.8,5.8-2.4c2.6-0.5,3.9-0.8,5.2,0.1s1.8,2.2,2.8,5C671.4,192.6,672,194.1,671.5,195.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_299",
    className: "st11",
    d: "M693.9,225.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_300",
    className: "st10",
    d: "M657,200.5c-0.8,1.9-2.8,2.5-5.5,3.3c-3.1,0.9-5,1.5-6.8,0.1c-2-1.5-2.3-4.5-2.5-6.9   s-0.7-5.9,1.2-8c0.9-1,1.7-0.7,6.1-1.2c1.9-0.2,3.5-0.5,4.5-0.7c0.5,0,1,0.2,1.4,0.5c1.2,1,1,2.9,1.3,6.7   C657,199.1,657.4,199.4,657,200.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_301",
    className: "st10",
    d: "M633.5,199.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_302",
    className: "st10",
    d: "M662,214.8c-0.5,2.1-2.4,3-5,4.3c-2.9,1.5-4.8,2.4-6.6,1.5c-2.2-1.1-2.9-4-3.5-6.3   s-1.5-5.7,0.1-8.1c1-1.5,2.6-1.8,5.8-2.4c2.6-0.5,3.9-0.8,5.2,0.1s1.8,2.2,2.8,5C661.9,211.8,662.4,213.2,662,214.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_303",
    className: "st10",
    d: "M667,181.4c0,0.7-0.1,1.4-0.4,2c-0.8,1.3-2.3,0.6-5,1.2c-3,0.7-4,2.1-5.6,1.3   c-0.5-0.3-0.9-0.7-1.2-1.2c-1.4-2-2.4-4.4-2.7-6.8c-0.7-3.8-1.1-5.9-0.1-7.7c1.5-2.8,4.8-3,6.6-3.2s3.8-0.3,5.4,1.2   c1.1,1,1.5,3.1,2.5,7.2C667,177.3,667.1,179.4,667,181.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_304",
    className: "st10",
    d: "M668.8,172.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_305",
    className: "st10",
    d: "M655.2,186.7c-0.3,0.5-0.7,0.5-3.2,0.6c-5.5,0.3-6,0.7-7.2,0c-0.2-0.1-2.8-1.6-3-4.3   c-0.1-1.5,0.6-2.6,2.1-5s1.7-1.9,3.6-4.6c0.4-0.6,1-1.2,1.6-1.7c0.6-0.4,1.2-0.9,1.7-0.7c1.1,0.3,0.8,3.3,1.6,6.9   C653.4,183.1,656,185.3,655.2,186.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_306",
    className: "st10",
    d: "M650,180.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_307",
    className: "st10",
    d: "M677.8,183.5c-0.3,2.1-3.7,3.8-6.5,2.9c-1-0.3-1.9-0.9-2.5-1.7c-1.2-1.6-0.8-3-1.4-7   c-0.7-4.9-2-7.5-1-8.5c0.4-0.3,0.8-0.4,1.2-0.4c0.9-0.1,1.8,0.1,2.5,0.5c1.4,0.7,2.1,1.9,3.5,4c0.5,0.7,0.9,1.5,1.3,2.3   c0.2,0.5,0.3,0.7,0.9,2.2c0.8,1.8,0.8,1.7,0.9,2.2C677.5,181.8,677.9,182.7,677.8,183.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308",
    className: "st10",
    d: "M677.8,173.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309",
    className: "st10",
    d: "M676.4,210.9c-0.5,2.1-2.4,3-5,4.3c-2.9,1.5-4.8,2.4-6.6,1.5c-2.2-1.1-2.9-4-3.5-6.3   s-1.5-5.7,0.1-8.1c1-1.5,2.6-1.8,5.8-2.4c2.6-0.5,3.9-0.8,5.2,0.1s1.8,2.2,2.8,5C676.3,207.9,676.8,209.4,676.4,210.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_310",
    className: "st10",
    d: "M667.4,227.4c-0.2,1.7-1.7,2.5-3.9,3.8c-2.5,1.4-4,2.3-5.9,1.7c-2.2-0.7-3.3-2.9-4.3-4.7   s-2.3-4.4-1.3-6.4c0.7-1.2,2.1-1.6,5-2.4c2.3-0.6,3.5-0.9,4.8-0.3s2,1.6,3.4,3.7S667.5,226.1,667.4,227.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_311",
    className: "st10",
    d: "M673,220.3c-0.4,0.9-0.9,1.7-1.5,2.4c-1.9,2.5-2.9,3.7-3.6,3.4c-0.3-0.1-0.7-0.8-1.5-2.2   c-0.2-0.3-0.3-0.6-0.5-1c-0.5-0.8-0.8-1.6-0.8-2.5c0.1-0.7,0.3-1.4,0.8-1.9c0.7-0.8,1.2-0.7,3-1.4c2.1-0.8,2.6-1.5,3.3-1.1   c0.6,0.4,1,1,1.2,1.6C673.5,218.5,673.4,219.5,673,220.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_312",
    className: "st10",
    d: "M671.9,193.9c-0.8-3.9-2-5.2-1.4-6c0.3-0.4,0.6-0.1,2.4-0.4c1.1-0.2,2.2-0.6,3.3-1   c1.4-0.5,1.7-0.8,2.1-0.6c0.8,0.4,0.9,1.8,1.1,3.1s-0.1,1.8,0.2,3.7c0.1,0.9,0.2,1,0.2,1.9c0.2,1.8,0.2,2.8-0.2,3.5   c-0.3,0.4-0.6,0.5-2.5,0.9c-3.7,0.6-4.3,0.6-4.6,0.1c-0.2-0.3-0.1-0.6,0-1.4C672.4,196.4,672.2,195.1,671.9,193.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_313",
    className: "st10",
    d: "M677.2,188.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_314",
    className: "st10",
    d: "M672,188"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_315",
    className: "st10",
    d: "M674.2,191.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_316",
    className: "st10",
    d: "M676.8,202.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_317",
    className: "st10",
    d: "M674.5,202.6l-0.7-1.6c-0.4-0.8-0.5-0.9-0.5-1.1c0.1-0.4,1-0.1,2.8-0.3   c0.5-0.1,1.1-0.2,1.6-0.3c1-0.3,1.3-0.5,1.6-0.3c0.5,0.4,0.3,1.7,0.2,1.9c0,0.3-0.1,0.6-0.2,0.8c-0.1,0.2-0.2,0.3-0.2,0.4   c0,0.2,0,0.3,0.1,0.5c0,0.1,0,0.1,0,0.2c0,0.4,0,0.9-0.1,1.3c-0.1,0.6-0.4,1.2-0.9,1.6c-0.4,0.4-1.1,0.5-1.6,0.3   c-0.4-0.2-0.7-0.4-0.9-0.8c-0.2-0.3-0.4-0.7-0.5-1.1C675,203.6,674.7,203.1,674.5,202.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_318",
    className: "st11",
    d: "M680.6,204"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_319",
    className: "st10",
    d: "M646.2,214c-0.6,1.4-2,1.7-3.9,2.3c-2.2,0.6-3.6,1-4.8,0c-1.4-1.1-1.7-3.2-1.9-4.9   s-0.5-4.2,0.8-5.6c0.6-0.7,1.2-0.5,4.4-0.8c1.3-0.1,2.5-0.3,3.2-0.4c0.4,0,0.7,0.2,1,0.4c0.8,0.7,0.8,2,1,4.8   C646.2,213.1,646.5,213.3,646.2,214z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_320",
    className: "st10",
    d: "M650.2,223.4c-0.2,1.4-1.5,2.1-3.4,3c-2.1,1-3.4,1.7-4.9,1.1c-1.7-0.7-2.5-2.6-3.2-4.2   s-1.6-3.8-0.7-5.5c0.5-0.8,1.1-0.7,4.2-1.7c1.3-0.4,2.4-0.9,3.2-1.1c0.4-0.1,0.8,0,1.1,0.1c1,0.5,1.3,1.7,2.3,4.2   C650,222.6,650.3,222.7,650.2,223.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321",
    className: "st10",
    d: "M641.9,202.9c-0.4,0.9-1.2,1.1-2.5,1.5s-2.2,0.7-2.9,0.1s-0.9-2-1-3s-0.1-2.6,0.7-3.5   c0.4-0.4,0.8-0.3,2.6-0.6c0.8-0.1,1.5-0.2,2-0.3c0.2,0,0.4,0.1,0.6,0.2c0.5,0.4,0.4,1.2,0.4,3C641.9,202.3,642.1,202.4,641.9,202.9   z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_322",
    className: "st10",
    d: "M651.4,235.2c-0.8-0.3-1.6-0.8-2.2-1.4c-2.3-1.9-3.5-2.8-3.4-3.7c0-0.4,0.6-1,1.6-2.2   c0.2-0.2,0.4-0.5,0.7-0.8c0.9-0.8,1.4-1.3,2-1.4c0.6,0,1.2,0.2,1.7,0.7c0.8,0.7,0.8,1.4,1.7,3.3c1,2.4,1.6,2.8,1.4,3.8   c-0.2,1.3-1.4,2.1-2.7,1.9C651.9,235.4,651.7,235.3,651.4,235.2L651.4,235.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_323",
    className: "st10",
    d: "M639.2,195.1c-0.5-0.7-0.9-1.6-1.2-2.5c-0.3-0.8-0.4-1.7-0.5-2.6c0.5-2.6,1.1-2.9,1.4-3   l0.6-0.1c0.4-0.1,0.8-0.1,1.2-0.1c0.5,0.1,0.9,0.2,1.3,0.5c0.4,0.4,0.7,0.8,0.9,1.4c0.1,0.2,0.1,0.4,0.1,0.6c0,1,0,2-0.2,3   c-0.1,2.4,0.2,3.1-0.4,3.7c-0.4,0.4-1,0.6-1.6,0.5C640.2,196.3,639.6,195.8,639.2,195.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_324",
    className: "st10",
    d: "M631.7,191.8"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_46",
    transform: "matrix(0.9999 -1.692889e-02 1.692889e-02 0.9999 -3.4282 11.3372)",
    className: "st12",
    cx: 667.9,
    cy: 208.2,
    rx: 2.3,
    ry: 2.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_47",
    transform: "matrix(0.9999 -1.692889e-02 1.692889e-02 0.9999 -3.1635 11.2603)",
    className: "st12",
    cx: 663.5,
    cy: 192.5,
    rx: 2.3,
    ry: 2.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_48",
    transform: "matrix(0.9997 -2.390873e-02 2.390873e-02 0.9997 -4.8852 15.6791)",
    className: "st12",
    cx: 653.3,
    cy: 212.1,
    rx: 2.3,
    ry: 2.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_49",
    transform: "matrix(0.9999 -1.692889e-02 1.692889e-02 0.9999 -3.7316 11.2085)",
    className: "st12",
    cx: 660.2,
    cy: 226,
    rx: 2.3,
    ry: 2.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_50",
    transform: "matrix(0.9999 -1.692889e-02 1.692889e-02 0.9999 -3.2151 11.0279)",
    className: "st12",
    cx: 649.8,
    cy: 195.4,
    rx: 2.3,
    ry: 2.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_51",
    transform: "matrix(0.9999 -1.692889e-02 1.692889e-02 0.9999 -2.877 11.187)",
    className: "st12",
    cx: 659.3,
    cy: 175.5,
    rx: 2.3,
    ry: 2.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_52",
    transform: "matrix(3.210847e-02 -0.9995 0.9995 3.210847e-02 445.5751 823.8654)",
    className: "st12",
    cx: 648.2,
    cy: 181.9,
    rx: 2.2,
    ry: 1.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_53",
    transform: "matrix(3.210847e-02 -0.9995 0.9995 3.210847e-02 409.0307 844.5775)",
    className: "st12",
    cx: 640.6,
    cy: 211.1,
    rx: 2.2,
    ry: 1.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_54",
    transform: "matrix(3.210847e-02 -0.9995 0.9995 3.210847e-02 401.9386 857.8581)",
    className: "st12",
    cx: 643.9,
    cy: 221.4,
    rx: 2.2,
    ry: 1.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_55",
    transform: "matrix(6.975647e-02 -0.9976 0.9976 6.975647e-02 374.8919 863.8546)",
    className: "st12",
    cx: 650.6,
    cy: 230.9,
    rx: 1.6,
    ry: 1.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_56",
    transform: "matrix(4.886881e-03 -1 1 4.886881e-03 435.3853 838.3956)",
    className: "st12",
    cx: 638.9,
    cy: 200.4,
    rx: 1.3,
    ry: 1.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_57",
    transform: "matrix(4.886881e-03 -1 1 4.886881e-03 446.1814 830.4124)",
    className: "st12",
    cx: 640.3,
    cy: 191,
    rx: 1.3,
    ry: 1.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_58",
    transform: "matrix(0.1028 -0.9947 0.9947 0.1028 380.6932 864.3948)",
    className: "st12",
    cx: 669.5,
    cy: 221.2,
    rx: 1.4,
    ry: 1.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_59",
    transform: "matrix(0.9992 -3.978300e-02 3.978300e-02 0.9992 -7.5177 27.0978)",
    className: "st12",
    cx: 677.1,
    cy: 202.4,
    rx: 1,
    ry: 1.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_60",
    transform: "matrix(0.9968 -7.974522e-02 7.974522e-02 0.9968 -13.4762 54.5711)",
    className: "st14",
    cx: 676.5,
    cy: 196,
    rx: 1.7,
    ry: 1.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_61",
    transform: "matrix(0.9966 -8.298215e-02 8.298215e-02 0.9966 -12.4722 56.3376)",
    className: "st12",
    cx: 671.5,
    cy: 178.2,
    rx: 1.7,
    ry: 1.9
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_59"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_58"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_62",
    transform: "matrix(0.1747 -0.9846 0.9846 0.1747 296.8931 709.2167)",
    className: "st10",
    cx: 571.5,
    cy: 177.5,
    rx: 36.7,
    ry: 22.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_325"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M569.6,213.9L569.6,213.9c-1.5,0-2.9-0.2-4.4-0.5l-0.5-0.1c-4.8-1.1-8.9-4.2-11.3-8.4    c-1.4-2.6-2.2-5.5-2.5-8.5c-0.3-3.1-0.4-6.2-0.2-9.4c0.4-8.3,1.8-16.6,4.2-24.6c1.2-4.2,2.9-8.2,5.2-11.9l0.3-0.5    c0.9-1.4,2-2.6,3.2-3.8c1.1-1.1,2.4-2,3.7-2.7c2.5-1.4,5.3-2.2,8.2-2.2c2.2,0,4.4,0.5,6.5,1.4c2.2,1,4.2,2.4,5.8,4.2    c2.6,2.9,4.4,6.5,5.3,10.3c1,4,1.1,8.2,0.2,12.2c-0.8,3.9-2.6,7.6-5.1,10.7c-2.3,2.9-5.3,5-8.8,6.2l-0.5,0.2l0.4,0.4    c1.6,1.6,2.8,3.5,3.8,5.5c1,2.1,1.6,4.4,1.6,6.8c0.1,8-6.3,14.6-14.3,14.7C569.9,213.9,569.8,213.9,569.6,213.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M569.6,213.6c5.2,0.2,10.1-2.7,12.6-7.3c1.2-2.1,1.9-4.5,1.9-7c0-2.3-0.5-4.5-1.5-6.6c-1-2-2.2-3.9-3.8-5.5    l-0.8-0.8l1.1-0.3c3.4-1.2,6.4-3.3,8.6-6.1c2.5-3.1,4.2-6.7,5-10.5c0.8-4,0.8-8.1-0.2-12.1c-0.9-3.8-2.6-7.2-5.2-10.1    c-1.6-1.8-3.5-3.2-5.7-4.1c-2-0.9-4.1-1.4-6.3-1.4c-2.8,0-5.6,0.8-8.1,2.2c-1.3,0.7-2.5,1.6-3.6,2.7c-1.2,1.1-2.2,2.4-3.1,3.7    c-0.1,0.1-0.2,0.3-0.3,0.5c-2.2,3.7-4,7.6-5.1,11.8c-2.4,8-3.8,16.2-4.2,24.5c-0.2,3.1-0.1,6.2,0.2,9.3c0.3,2.9,1.1,5.7,2.5,8.3    c2.4,4.2,6.4,7.1,11.1,8.2l0.5,0.1C566.7,213.4,568.1,213.6,569.6,213.6L569.6,213.6 M569.6,214.3c-1.5,0-3-0.2-4.5-0.5l-0.6-0.1    c-4.9-1.1-9.1-4.3-11.6-8.6c-2.8-5.1-3.1-11.8-2.8-18c0.4-8.4,1.8-16.6,4.3-24.7c1.2-4.2,2.9-8.3,5.2-12l0.3-0.5    c3.9-5.8,9.7-8.9,15.4-8.9c4.8,0,9.3,2.1,12.5,5.7c5.1,5.5,7.3,14.7,5.5,22.8s-7.4,15-14.1,17.1c3,3.2,5.5,7.6,5.5,12.5    c-0.1,5.1-2.6,9.9-6.9,12.7C575.4,213.5,572.5,214.3,569.6,214.3L569.6,214.3z"
  })))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_63"
  }, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7645 -0.6447 0.6447 0.7645 25.2212 578.14)",
    className: "st6",
    cx: 803.8,
    cy: 254.6,
    rx: 24.6,
    ry: 30
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7639 -0.6453 0.6453 0.7639 25.4169 578.8681)",
    className: "st7",
    cx: 803.8,
    cy: 254.7,
    rx: 24.2,
    ry: 29.7
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    id: "Group_60"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_64"
  }, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9251 -0.3798 0.3798 0.9251 -38.2382 328.2362)",
    className: "st6",
    cx: 812.8,
    cy: 261,
    rx: 17.3,
    ry: 19.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9243 -0.3817 0.3817 0.9243 -38.0813 330.0148)",
    className: "st7",
    cx: 812.8,
    cy: 261,
    rx: 17,
    ry: 18.9
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_65"
  }, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9257 -0.3782 0.3782 0.9257 -35.1845 320.6052)",
    className: "st6",
    cx: 798.5,
    cy: 249.9,
    rx: 17.4,
    ry: 19.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9243 -0.3817 0.3817 0.9243 -34.4059 322.119)",
    className: "st7",
    cx: 794.7,
    cy: 247.8,
    rx: 17,
    ry: 18.9
  })))), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_66",
    transform: "matrix(0.8521 -0.5234 0.5234 0.8521 -17.3384 466.3968)",
    className: "st12",
    cx: 816.5,
    cy: 263.9,
    rx: 2.9,
    ry: 3.3
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_67",
    transform: "matrix(0.853 -0.5219 0.5219 0.853 -15.0999 452.9934)",
    className: "st15",
    cx: 796.7,
    cy: 253.3,
    rx: 2.9,
    ry: 3.3
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Group_62"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_68",
    transform: "matrix(0.1747 -0.9846 0.9846 0.1747 320.6343 759.7029)",
    className: "st10",
    cx: 613.5,
    cy: 188.6,
    rx: 36.7,
    ry: 22.2
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Path_326"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M610.8,221.5c-1.6,0-3.2-0.2-4.7-0.5l-0.5-0.1c-5.1-1.2-9.1-4-11.4-7.8c-1.4-2.4-2.2-5-2.5-7.7   c-0.3-2.8-0.3-5.7-0.1-8.5c0.5-7.6,2.1-15.1,4.6-22.3c1.3-3.8,3.1-7.5,5.4-10.8l0.3-0.4c0.9-1.2,2-2.4,3.2-3.4   c1.2-1,2.4-1.8,3.8-2.5c2.6-1.3,5.4-2,8.3-2c4.7,0,9.2,1.9,12.5,5.2c2.5,2.6,4.3,5.8,5.2,9.4c0.9,3.6,0.9,7.5,0,11.1   c-1,4-5.3,7.5-8.8,9.7c-3.9,2.5-8.1,4.4-12.5,5.8l-0.6,0.2l0.4,0.4c0.5,0.4,1.1,0.6,1.7,0.6l0,0c1.4,0,3.4-0.8,5.5-1.6   c2.4-1,5.2-2.1,7.5-2.1c0.9-0.1,1.8,0.1,2.6,0.6c0.8,0.5,1.5,1.3,1.9,2.2c0.2,0.4,0.3,1.6-0.9,4.5c-1.1,2.5-2.4,4.8-3.9,7.1   c-1.5,2.4-3.2,4.7-5,6.9c-1.1,1.5-2.4,2.9-4,4C616.4,220.9,613.6,221.6,610.8,221.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M610.8,221.2c2.7,0.1,5.4-0.6,7.8-2c1.8-1,5.5-5.7,8.8-10.7c1.5-2.2,2.8-4.6,3.9-7.1c1.2-2.9,1.1-3.9,0.9-4.2   c-0.6-1.7-2.3-2.8-4.1-2.6c-2.2,0-5,1.1-7.4,2.1c-2.2,0.9-4.1,1.7-5.6,1.7c-0.7,0-1.4-0.2-1.9-0.7l-0.9-0.9l1.2-0.3   c4.4-1.3,8.6-3.2,12.5-5.7c2-1.3,3.9-2.8,5.6-4.5c1.4-1.4,2.4-3.1,3-5c0.9-3.6,0.9-7.4,0-10.9c-0.8-3.5-2.6-6.6-5.1-9.2   c-3.2-3.3-7.6-5.1-12.2-5.1c-2.8,0-5.6,0.7-8.2,2c-1.3,0.7-2.6,1.5-3.7,2.4c-1.2,1-2.2,2.1-3.2,3.3l-0.3,0.4   c-2.3,3.3-4.1,6.9-5.3,10.7c-2.5,7.2-4.1,14.7-4.6,22.2c-0.3,2.8-0.2,5.6,0.1,8.4c0.3,2.7,1.1,5.2,2.4,7.5   c2.2,3.7,6.2,6.4,11.2,7.6l0.5,0.1C607.7,221.1,609.3,221.2,610.8,221.2 M610.8,221.9c-1.6,0-3.2-0.2-4.8-0.5l-0.6-0.1   c-4.6-1.1-9-3.6-11.6-7.9c-2.8-4.7-3-10.7-2.6-16.4c0.5-7.7,2.1-15.2,4.6-22.4c1.3-3.9,3.1-7.5,5.4-10.9l0.3-0.4   c3.7-5,9.4-7.9,15.6-8c4.8,0,9.3,1.9,12.7,5.3c5.1,5.1,7.2,13.4,5.3,20.8s-14.7,13.8-21.5,15.7c0.4,0.4,0.9,0.5,1.5,0.5   c3,0,8.7-3.7,13-3.7c2.1-0.1,4,1.1,4.7,3c1.7,3.6-10,20.6-13.9,22.9C616.5,221.2,613.7,222,610.8,221.9L610.8,221.9z"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Group_63"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_327",
    className: "st16",
    d: "M1143.8,181.9c-12.3,3.7-25.6,0.3-29.7-7.6c-4.5-8.8,4-18.4,14.9-21.1s20.5,2.4,21.4,2.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328",
    className: "st16",
    d: "M1128.9,153.1c-12.3,3.7-19,13.2-14.8,21.1c4.5,8.8,19.4,11.3,29.7,7.6c6.3-2,11.1-7,13-13.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_329",
    className: "st17",
    d: "M1156.9,168.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_330",
    className: "st16",
    d: "M1189.3,144.2c-0.9-2,2.5-4.8,7.6-6.3s10.1-1.1,11,0.8"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_7",
    className: "st16",
    x1: 1150.4,
    y1: 156,
    x2: 1189.3,
    y2: 144.2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_8",
    className: "st16",
    x1: 1208,
    y1: 138.6,
    x2: 1256.6,
    y2: 123.9
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_331",
    className: "st16",
    d: "M1256.6,123.9c3.9-1.2,8.4,0.4,10,3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_332",
    className: "st16",
    d: "M1195.9,156.8c1.1,1.9,6.1,2.2,11.2,0.6s8.4-4.4,7.3-6.3"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_9",
    className: "st16",
    x1: 1156.9,
    y1: 168.6,
    x2: 1195.8,
    y2: 156.8
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10",
    className: "st16",
    x1: 1214.5,
    y1: 151.1,
    x2: 1263.1,
    y2: 136.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_333",
    className: "st16",
    d: "M1263.1,136.5c3.9-1.2,5.8-4.7,4.1-7.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_334",
    className: "st18",
    d: "M1140.9,144.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_335",
    className: "st19",
    d: "M1171.3,148.1"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_69",
    className: "st20",
    cx: 1110.9,
    cy: 192.9,
    rx: 2.5,
    ry: 1.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_70",
    transform: "matrix(0.9592 -0.2828 0.2828 0.9592 -8.2666 323.675)",
    className: "st21",
    cx: 1116.9,
    cy: 190.5,
    rx: 2.4,
    ry: 1.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_71",
    className: "st22",
    cx: 1116.4,
    cy: 169.2,
    rx: 2,
    ry: 2.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_72",
    className: "st23",
    cx: 1121.6,
    cy: 174.3,
    rx: 3.7,
    ry: 2.8
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_73",
    className: "st24",
    cx: 1115.4,
    cy: 197.1,
    rx: 3,
    ry: 2.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_74",
    className: "st25",
    cx: 1121.8,
    cy: 165.2,
    rx: 3.7,
    ry: 2.8
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_75",
    className: "st26",
    cx: 1120.7,
    cy: 170.2,
    rx: 1.7,
    ry: 1.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_76",
    className: "st27",
    cx: 1124.7,
    cy: 170.2,
    rx: 1.7,
    ry: 1.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_77",
    className: "st28",
    cx: 1126.2,
    cy: 167.3,
    rx: 1.1,
    ry: 0.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_78",
    className: "st29",
    cx: 1115.1,
    cy: 164.7,
    rx: 1.8,
    ry: 0.8
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_79",
    className: "st26",
    cx: 1120.8,
    cy: 159.6,
    rx: 1.7,
    ry: 1.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_80",
    transform: "matrix(0.9938 -0.1109 0.1109 0.9938 -10.4411 125.7372)",
    className: "st27",
    cx: 1124.6,
    cy: 156.7,
    rx: 3.8,
    ry: 1.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_81",
    className: "st30",
    cx: 1122.7,
    cy: 161.4,
    rx: 1.1,
    ry: 0.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_82",
    transform: "matrix(3.437623e-02 -0.9994 0.9994 3.437623e-02 904.4225 1282.2084)",
    className: "st31",
    cx: 1115.7,
    cy: 173.1,
    rx: 0.7,
    ry: 1.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_83",
    className: "st32",
    cx: 1110.4,
    cy: 161,
    rx: 2.1,
    ry: 1.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_84",
    transform: "matrix(0.4644 -0.8856 0.8856 0.4644 449.6467 1071.1693)",
    className: "st33",
    cx: 1110.4,
    cy: 163.8,
    rx: 0.7,
    ry: 1.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_85",
    className: "st26",
    cx: 1157.9,
    cy: 152.8,
    rx: 1.7,
    ry: 1.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_86",
    className: "st34",
    cx: 1167.9,
    cy: 147.8,
    rx: 1.7,
    ry: 1.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_87",
    className: "st35",
    cx: 1174.9,
    cy: 140.3,
    rx: 1.7,
    ry: 1.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_88",
    className: "st26",
    cx: 1176.9,
    cy: 148.6,
    rx: 1.7,
    ry: 1.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_89",
    className: "st36",
    cx: 1157.9,
    cy: 144.5,
    rx: 1.7,
    ry: 1.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_90",
    className: "st26",
    cx: 1176.9,
    cy: 151.9,
    rx: 1.7,
    ry: 1.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_91",
    className: "st37",
    cx: 1164.9,
    cy: 153.6,
    rx: 3.7,
    ry: 2.8
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_92",
    className: "st38",
    cx: 1150.2,
    cy: 143.4,
    rx: 3.7,
    ry: 2.8
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_93",
    className: "st21",
    cx: 1155.8,
    cy: 156.5,
    rx: 3.7,
    ry: 2.8
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_94",
    className: "st25",
    cx: 1183.7,
    cy: 153.2,
    rx: 3.7,
    ry: 2.8
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_95",
    className: "st25",
    cx: 1148.8,
    cy: 150.7,
    rx: 3.7,
    ry: 2.8
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_96",
    transform: "matrix(0.8823 -0.4707 0.4707 0.8823 42.5524 545.3623)",
    className: "st39",
    cx: 1111.7,
    cy: 187.6,
    rx: 3.4,
    ry: 1.8
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_97",
    transform: "matrix(0.3738 -0.9275 0.9275 0.3738 529.1292 1153.8949)",
    className: "st40",
    cx: 1119.1,
    cy: 185.1,
    rx: 2.1,
    ry: 2.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_98",
    transform: "matrix(0.4368 -0.8996 0.8996 0.4368 490.2457 1119.1656)",
    className: "st40",
    cx: 1138.9,
    cy: 168.1,
    rx: 2.2,
    ry: 2.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_99",
    transform: "matrix(0.3738 -0.9275 0.9275 0.3738 603.687 1171.952)",
    className: "st41",
    cx: 1169.8,
    cy: 138.9,
    rx: 2.1,
    ry: 2.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_100",
    transform: "matrix(0.411 -0.9116 0.9116 0.411 554.0905 1147.0984)",
    className: "st42",
    cx: 1164.8,
    cy: 144.7,
    rx: 2.1,
    ry: 2.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_101",
    transform: "matrix(0.3738 -0.9275 0.9275 0.3738 536.5991 1139.1365)",
    className: "st43",
    cx: 1111.9,
    cy: 172.2,
    rx: 2.1,
    ry: 2.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_102",
    transform: "matrix(0.3738 -0.9275 0.9275 0.3738 549.1263 1136.0608)",
    className: "st44",
    cx: 1115.9,
    cy: 161.4,
    rx: 2.1,
    ry: 2.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_103",
    transform: "matrix(0.3738 -0.9275 0.9275 0.3738 556.7708 1145.7134)",
    className: "st45",
    cx: 1126.9,
    cy: 160.5,
    rx: 2.1,
    ry: 2.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_104",
    transform: "matrix(0.3738 -0.9275 0.9275 0.3738 552.5387 1155.6707)",
    className: "st44",
    cx: 1132.1,
    cy: 168.6,
    rx: 2.1,
    ry: 2.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_105",
    transform: "matrix(0.3738 -0.9275 0.9275 0.3738 562.572 1148.9027)",
    className: "st44",
    cx: 1132.1,
    cy: 157.8,
    rx: 2.1,
    ry: 2.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_106",
    transform: "matrix(0.3637 -0.9315 0.9315 0.3637 550.7571 1140.2448)",
    className: "st46",
    cx: 1110.1,
    cy: 167,
    rx: 2.2,
    ry: 2.6
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_107",
    transform: "matrix(0.9774 -0.2113 0.2113 0.9774 -8.8088 243.2024)",
    className: "st20",
    cx: 1133.4,
    cy: 162.8,
    rx: 3.9,
    ry: 2.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_108",
    transform: "matrix(0.3738 -0.9275 0.9275 0.3738 593.0656 1180.6317)",
    className: "st47",
    cx: 1170.9,
    cy: 151.1,
    rx: 2.1,
    ry: 2.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_109",
    transform: "matrix(0.9774 -0.2113 0.2113 0.9774 -3.4818 256.3983)",
    className: "st31",
    cx: 1197.8,
    cy: 144.5,
    rx: 3.9,
    ry: 2.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_110",
    transform: "matrix(0.9774 -0.2113 0.2113 0.9774 -3.2386 248.6962)",
    className: "st32",
    cx: 1161.9,
    cy: 139.5,
    rx: 3.9,
    ry: 2.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_111",
    transform: "matrix(0.9774 -0.2113 0.2113 0.9774 -5.2615 248.0604)",
    className: "st20",
    cx: 1157.9,
    cy: 148.6,
    rx: 3.9,
    ry: 2.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_112",
    transform: "matrix(0.411 -0.9116 0.9116 0.411 565.5261 1159.423)",
    className: "st40",
    cx: 1180.1,
    cy: 142,
    rx: 2.1,
    ry: 2.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_113",
    transform: "matrix(0.411 -0.9116 0.9116 0.411 540.1975 1155.1591)",
    className: "st40",
    cx: 1164.1,
    cy: 159.5,
    rx: 2.1,
    ry: 2.5
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_336",
    className: "st48",
    d: "M942.8,304.8"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Group_64"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_114"
  }, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(1.396295e-03 -1 1 1.396295e-03 607.1797 1139.8119)",
    className: "st49",
    cx: 874.3,
    cy: 265.9,
    rx: 22.5,
    ry: 26.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(1.396295e-03 -1 1 1.396295e-03 607.1698 1139.8218)",
    className: "st50",
    cx: 874.3,
    cy: 265.9,
    rx: 22.2,
    ry: 26.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_115"
  }, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(1.396295e-03 -1 1 1.396295e-03 580.092 1166.7817)",
    className: "st49",
    cx: 874.3,
    cy: 292.9,
    rx: 22.5,
    ry: 26.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(1.396295e-03 -1 1 1.396295e-03 580.102 1166.7917)",
    className: "st50",
    cx: 874.3,
    cy: 292.9,
    rx: 22.2,
    ry: 26.1
  })))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Path_337"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M942.2,314.9c-2.8,0-5.6-0.4-8.3-1.1c-5.7-1.5-10.3-5.5-12.7-10.9c-1.3-2.8-2.2-5.7-2.8-8.8   c-1.8-8-2.3-16.2-1.6-24.4c0.3-4.4,1.3-8.7,3.1-12.7l0.2-0.5c2-4.1,5.2-7.5,9.2-9.7c4-2.3,8.6-3.5,13.2-3.5c1.9,0,3.7,0.2,5.6,0.6   c1.9,0.4,3.7,1,5.4,1.9c3.8,1.8,7.1,4.7,9.4,8.2c4.8,6.9,4.9,16,0.3,23c-2.2,3.6-5.4,6.5-9.2,8.4l-0.7,0.3l0.7,0.3   c2.3,1.1,4.4,2.5,6.3,4.2c1.8,1.6,3.1,3.6,3.8,5.9c0.7,2.4,0.5,5-0.4,7.3c-1,2.4-2.5,4.6-4.5,6.3c-2.1,1.7-4.4,3-7,3.8   c-2.6,0.8-5.4,1.3-8.1,1.5h-0.7C943,314.9,942.6,314.9,942.2,314.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st49",
    d: "M942.2,314.6L942.2,314.6h1.1h0.7c2.7-0.1,5.4-0.6,8-1.5c2.5-0.8,4.9-2.1,6.9-3.7c2-1.6,3.5-3.7,4.4-6.1   c0.9-2.3,1-4.7,0.4-7.1c-0.7-2.2-2-4.2-3.7-5.8c-1.8-1.7-3.9-3.1-6.2-4.1l-1.3-0.6l1.3-0.6c3.7-1.9,6.8-4.7,9-8.2   c4.5-6.9,4.4-15.8-0.3-22.6c-2.3-3.5-5.5-6.3-9.3-8.1c-1.7-0.8-3.5-1.4-5.3-1.8c-1.8-0.4-3.6-0.6-5.5-0.6c-2.3,0-4.6,0.3-6.8,0.9   c-2.2,0.6-4.3,1.5-6.2,2.6c-3.9,2.2-7,5.6-9,9.6c-0.1,0.2-0.2,0.3-0.2,0.5c-1.7,4-2.7,8.2-3,12.5c-0.8,8.1-0.2,16.3,1.6,24.3   c0.6,3,1.5,5.9,2.8,8.7c1.2,2.8,3.1,5.2,5.4,7.1c2.1,1.7,4.5,2.9,7.1,3.6C936.7,314.3,939.5,314.7,942.2,314.6 M942.2,315.3   c-5.7,0-11.4-1.4-15.7-4.9c-5-4-7.2-10.2-8.5-16.2c-1.8-8-2.4-16.3-1.6-24.5c0.3-4.4,1.4-8.7,3.1-12.8c0.1-0.2,0.2-0.4,0.2-0.5   c4-8.4,13.2-13.5,22.7-13.5c3.8,0,7.6,0.8,11.1,2.5c7.9,3.8,13.2,11.8,13.3,20s-5,16.3-12.7,20.2c4.6,2.2,8.9,5.6,10.3,10.3   c1.5,5-0.9,10.5-5,14s-9.8,5-15.3,5.3c-0.2,0-0.5,0-0.7,0S942.6,315.3,942.2,315.3L942.2,315.3z"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Group_65"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_338",
    className: "st52",
    d: "M1161.4,280c6.2,5.9,6,3.4,4.9,13.9c-1.1,10.9-12.9,21.5-23.6,21.5c-4.1,0-8.7-2.1-11.7-4.1   c-7.9-5.3-10.3-12.1-10.7-14.3c-1.4-9.3,5.9-17.1,7.8-19c0.1-0.1,0.1-0.2,0-0.3l0,0c-1.3-1.5-2.5-3-3.6-4.6   c-1.8-3.7-2.4-7.9-1.8-12.1c1-9.8,11.3-17.6,22.2-16.9c12.2,0.8,19.9,12.3,22.7,20.1c6.4,18.4,5.5,27.4-2.1,19.4 M1136.9,294.3   c0.2,0.7,1.1,3,3.4,3.4c1.2,0.2,2.5-0.1,3.4-0.9c1.4-1.4-0.1-3.8-1.3-5c-1.3-1.1-3-1.8-4.8-2c-0.1,0-0.2,0-0.3,0.1   C1136.5,291.2,1136.3,292.8,1136.9,294.3L1136.9,294.3z M1147.7,267.8c0.1-0.1,9.8,10.1,13.4,12.2c0.2,0.1,0.5-0.1,0.3-0.4   c-2.1-2.4-4.3-4.8-6.5-7.2c-2-2.1-4.2-5.3-7.2-6.2c-0.3-0.1-0.9-0.3-1.2,0s0.3,0.9,0.5,1.1L1147.7,267.8"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_339",
    d: "M1151,295.2"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_340",
    d: "M1022.6,261.9"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_341",
    d: "M1045.8,280.9"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_116",
    transform: "matrix(1.570732e-03 -1 1 1.570732e-03 587.9909 1159.3029)",
    className: "st53",
    cx: 874.6,
    cy: 285.2,
    rx: 3.9,
    ry: 4.4
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_117",
    transform: "matrix(1.570732e-03 -1 1 1.570732e-03 613.0102 1134.3829)",
    className: "st53",
    cx: 874.6,
    cy: 260.2,
    rx: 3.9,
    ry: 4.4
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "Group_66"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_118",
    transform: "matrix(1.047886e-03 -1 1 1.047886e-03 796.8513 1357.4729)",
    className: "st52",
    cx: 1077.9,
    cy: 279.9,
    rx: 36.1,
    ry: 27.1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_11",
    className: "st50",
    x1: 1082.8,
    y1: 244.4,
    x2: 1078.2,
    y2: 292
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "Path_342"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st52",
    d: "M1008.1,315.2c-2.8,0-5.6-0.4-8.3-1.1c-5.7-1.5-10.3-5.5-12.7-10.9c-1.3-2.8-2.2-5.7-2.8-8.8   c-1.8-8-2.3-16.2-1.6-24.4c0.3-4.4,1.3-8.7,3.1-12.7l0.2-0.5c2-4.1,5.2-7.5,9.2-9.7c2-1.1,4.1-2,6.3-2.6c2.2-0.6,4.6-0.9,6.9-0.9   c1.9,0,3.7,0.2,5.6,0.6c1.9,0.4,3.7,1,5.4,1.9c3.8,1.8,7.1,4.7,9.4,8.2c2.3,3.4,3.6,7.4,3.7,11.5c-0.1,2.2-0.8,4.4-2.1,6.2   c-1.6,2.3-3.4,4.5-5.5,6.4c-4.1,3.8-8.6,7-13.5,9.6l-0.6,0.3l0.7,0.3c0.4,0.2,0.8,0.3,1.2,0.2l0,0c1.9,0,4.3-1.6,7.2-3.4   c3.3-2.1,7.1-4.6,10.5-4.6c1.7,0,3.3,0.7,4.5,2c0.5,0.8,0.7,1.7,0.6,2.7c-0.1,3-1.6,8.2-3.9,13.7c-2.2,5.2-4.6,9.4-6.2,10.8   c-2.1,1.7-4.4,3-7,3.8c-2.6,0.8-5.4,1.3-8.1,1.4h-0.7L1008.1,315.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st49",
    d: "M1008.1,314.9L1008.1,314.9h1.1h0.7c2.7-0.1,5.4-0.6,8.1-1.4c2.5-0.8,4.9-2.1,6.9-3.8c1.5-1.3,4-5.6,6.1-10.7   c2.3-5.5,3.8-10.6,3.9-13.6c0.1-0.8,0-1.7-0.5-2.4c-1.1-1.2-2.6-1.9-4.2-1.9c-3.3,0-7,2.4-10.3,4.5c-2.9,1.8-5.4,3.4-7.4,3.4   c-0.5,0-0.9-0.1-1.3-0.3l-1.3-0.6l1.3-0.6c4.9-2.6,9.4-5.8,13.5-9.5c2.1-1.9,3.9-4,5.4-6.3c1.3-1.8,2-3.8,2.1-6   c-0.1-4-1.3-7.9-3.6-11.3c-2.3-3.5-5.5-6.3-9.3-8.1c-1.7-0.8-3.5-1.4-5.3-1.9c-1.8-0.4-3.6-0.6-5.5-0.6c-2.3,0-4.6,0.3-6.8,0.9   c-2.2,0.6-4.3,1.5-6.2,2.6c-3.9,2.2-7,5.6-9,9.6c-0.1,0.1-0.2,0.3-0.2,0.5c-1.7,4-2.7,8.2-3,12.6c-0.7,8.1-0.2,16.3,1.6,24.2   c0.6,3,1.6,5.9,2.8,8.7c2.3,5.3,6.9,9.3,12.4,10.7C1002.6,314.5,1005.4,314.9,1008.1,314.9 M1008.1,315.6c-5.7,0-11.4-1.4-15.7-4.9   c-5-4-7.2-10.2-8.5-16.2c-1.8-8-2.4-16.3-1.6-24.5c0.3-4.4,1.4-8.7,3.1-12.8l0.2-0.5c4-8.4,13.2-13.5,22.7-13.5   c3.8,0,7.6,0.9,11.1,2.5c7.9,3.8,13.2,11.8,13.3,20c0.1,8.2-13.6,18.5-21.3,22.5c0.3,0.1,0.7,0.2,1,0.2c4,0,11.4-8,17.7-8   c1.8,0,3.5,0.7,4.7,2c3.2,3.3-5.5,24.2-9.6,27.7c-4,3.5-9.8,5-15.3,5.3h-0.7L1008.1,315.6z"
  }))), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_119",
    className: "st20",
    cx: 943,
    cy: 261.9,
    rx: 3.1,
    ry: 2
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_120",
    transform: "matrix(0.9656 -0.2602 0.2602 0.9656 -34.6129 256.1751)",
    className: "st21",
    cx: 950.4,
    cy: 258.8,
    rx: 3,
    ry: 2.1
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_121",
    className: "st24",
    cx: 948.5,
    cy: 266.9,
    rx: 3.7,
    ry: 3
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_122",
    transform: "matrix(0.8932 -0.4496 0.4496 0.8932 -14.1053 451.7342)",
    className: "st39",
    cx: 944,
    cy: 255.6,
    rx: 4.2,
    ry: 2.2
  })), _ellipse0 || (_ellipse0 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_123",
    transform: "matrix(0.5525 -0.8335 0.8335 0.5525 296.6644 1069.1188)",
    className: "st25",
    cx: 1144,
    cy: 258.3,
    rx: 3.7,
    ry: 4.3
  })), _ellipse1 || (_ellipse1 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_124",
    transform: "matrix(0.5223 -0.8527 0.8527 0.5223 333.345 1097.6511)",
    className: "st26",
    cx: 1146.5,
    cy: 251.3,
    rx: 1.5,
    ry: 1.9
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_125",
    transform: "matrix(0.3756 -0.9268 0.9268 0.3756 487.5359 1223.7631)",
    className: "st27",
    cx: 1151.9,
    cy: 250.1,
    rx: 1.7,
    ry: 4.3
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_126",
    transform: "matrix(0.5101 -0.8601 0.8601 0.5101 343.4576 1110.5024)",
    className: "st30",
    cx: 1146.5,
    cy: 253.8,
    rx: 0.9,
    ry: 1.3
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_127",
    transform: "matrix(0.9345 -0.3561 0.3561 0.9345 -15.5906 426.9815)",
    className: "st45",
    cx: 1152,
    cy: 255.8,
    rx: 2.6,
    ry: 3
  })), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_128",
    transform: "matrix(0.9345 -0.3561 0.3561 0.9345 -15.0847 429.4231)",
    className: "st44",
    cx: 1158.9,
    cy: 255.7,
    rx: 2.6,
    ry: 3
  })), _ellipse14 || (_ellipse14 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_129",
    transform: "matrix(0.2416 -0.9704 0.9704 0.2416 623.3793 1321.5409)",
    className: "st20",
    cx: 1157.1,
    cy: 262,
    rx: 3.3,
    ry: 4.5
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_343",
    className: "st19",
    d: "M1065,266.9"
  })), _ellipse15 || (_ellipse15 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_130",
    transform: "matrix(0.3572 -0.934 0.934 0.3572 431.5999 1166.3041)",
    className: "st34",
    cx: 1063.2,
    cy: 269.6,
    rx: 1.6,
    ry: 1.1
  })), _ellipse16 || (_ellipse16 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_131",
    transform: "matrix(0.3572 -0.934 0.934 0.3572 441.2119 1166.0938)",
    className: "st26",
    cx: 1067.8,
    cy: 262.5,
    rx: 1.6,
    ry: 1.1
  })), _ellipse17 || (_ellipse17 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_132",
    transform: "matrix(0.3572 -0.934 0.934 0.3572 441.2592 1169.9225)",
    className: "st26",
    cx: 1070.6,
    cy: 264.4,
    rx: 1.6,
    ry: 1.1
  })), _ellipse18 || (_ellipse18 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_133",
    transform: "matrix(0.2865 -0.9581 0.9581 0.2865 497.2562 1218.5593)",
    className: "st37",
    cx: 1066.8,
    cy: 275.4,
    rx: 3.6,
    ry: 2.8
  })), _ellipse19 || (_ellipse19 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_134",
    transform: "matrix(0.2865 -0.9581 0.9581 0.2865 518.3123 1214.6843)",
    className: "st25",
    cx: 1074.7,
    cy: 259.3,
    rx: 3.6,
    ry: 2.8
  })), _ellipse20 || (_ellipse20 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_135",
    transform: "matrix(0.6267 -0.7792 0.7792 0.6267 184.6336 926.3608)",
    className: "st42",
    cx: 1059.3,
    cy: 270.5,
    rx: 2.3,
    ry: 2.2
  })), _ellipse21 || (_ellipse21 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_136",
    transform: "matrix(0.6441 -0.7649 0.7649 0.6441 174.0819 912.1683)",
    className: "st47",
    cx: 1067.3,
    cy: 269,
    rx: 2.3,
    ry: 2.1
  })), _ellipse22 || (_ellipse22 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_137",
    transform: "matrix(0.1699 -0.9855 0.9855 0.1699 605.109 1275.3923)",
    className: "st20",
    cx: 1059.6,
    cy: 278.5,
    rx: 3.8,
    ry: 2.5
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_138",
    className: "st40",
    d: "M1062,254.7c0.8-1,2.2-1.2,3.1-0.4c0.9,0.8,1.1,2.2,0.3,3.2c-0.8,1-2.2,1.2-3.1,0.4  C1061.3,257.1,1061.2,255.7,1062,254.7z"
  })), _ellipse23 || (_ellipse23 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_139",
    transform: "matrix(0.6267 -0.7792 0.7792 0.6267 182.1513 939.145)",
    className: "st40",
    cx: 1071.4,
    cy: 279.4,
    rx: 2.3,
    ry: 2.2
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_344",
    className: "st22",
    d: "M1011.9,274.4c-1.2,0-2.1-1.9-2.1-4.2s0.9-4.2,2.1-4.2s2.1,1.9,2.1,4.2S1013,274.4,1011.9,274.4  "
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_345",
    className: "st25",
    d: "M1021.5,264.5c-0.1,2.2-1.9,3.9-4.1,3.8c-2.2-0.1-3.9-1.9-3.8-4.1c0.1-2.1,1.8-3.8,3.9-3.8l0,0  C1019.7,260.4,1021.5,262.2,1021.5,264.5C1021.5,264.5,1021.5,264.5,1021.5,264.5"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_346",
    className: "st26",
    d: "M1014.7,271.6c0-1,0.8-1.8,1.8-1.8s1.8,0.8,1.8,1.8"
  })), _ellipse24 || (_ellipse24 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_140",
    className: "st29",
    cx: 1010.6,
    cy: 263.6,
    rx: 1.9,
    ry: 1.2
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_347",
    className: "st26",
    d: "M1016.5,254.7c0.9,0,1.7,0.7,1.8,1.6c0,0,0,0,0,0"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Path_348",
    className: "st26",
    d: "M1018.3,256.3c0.1,1-0.6,1.9-1.6,2c-1,0.1-1.9-0.6-2-1.5c0,0,0,0,0-0.1c-0.1-1,0.6-1.9,1.6-2  h0.2"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Path_349",
    className: "st30",
    d: "M1018.5,260c-0.5,0.1-1.1-0.2-1.2-0.8c0,0,0,0,0,0c-0.1-0.5,0.2-1.1,0.7-1.2c0,0,0,0,0,0  c0.1,0,0.3,0,0.4,0"
  })), _ellipse25 || (_ellipse25 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_141",
    className: "st32",
    cx: 1005.6,
    cy: 258.4,
    rx: 2.2,
    ry: 1.7
  })), _ellipse26 || (_ellipse26 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_142",
    transform: "matrix(0.8154 -0.5789 0.5789 0.8154 33.7151 630.4916)",
    className: "st33",
    cx: 1005.5,
    cy: 262.4,
    rx: 0.9,
    ry: 1.3
  })), _ellipse27 || (_ellipse27 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_143",
    transform: "matrix(0.9387 -0.3446 0.3446 0.9387 -27.3023 364.4427)",
    className: "st44",
    cx: 1011.4,
    cy: 259,
    rx: 2.5,
    ry: 3.1
  })), _ellipse28 || (_ellipse28 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_144",
    transform: "matrix(0.9409 -0.3386 0.3386 0.9409 -31.0185 356.1038)",
    className: "st46",
    cx: 1005.2,
    cy: 267,
    rx: 2.7,
    ry: 3.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromoterHeader);
export default __webpack_public_path__ + "static/media/promoterHeader.e1dfa2d9eb38db175c6f172c933e661e.svg";
export { ForwardRef as ReactComponent };